var _rect, _rect2, _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path10, _g4, _path11, _path12, _g5, _path13, _path14, _g6, _path15, _path16, _g7, _path17, _path18, _g8, _path19, _path20, _g9, _path21, _path22, _g10, _path23, _path24, _g11, _path25, _path26, _g12, _path27, _path28, _g13, _path29, _path30, _g14, _path31, _path32, _g15, _path33, _path34, _g16, _path35, _path36, _g17, _path37, _path38, _g18, _path39, _path40, _g19, _path41, _path42, _g20, _path43, _path44, _g21, _path45, _path46, _g22, _path47, _path48, _g23, _path49, _path50, _g24, _path51, _path52, _g25, _path53, _rect3, _path54, _path55, _path56, _g26, _path57, _path58, _g27, _path59, _path60, _g28, _path61, _path62, _g29, _path63, _path64, _g30, _path65, _path66, _g31, _path67, _path68, _g32, _path69, _path70, _g33, _path71, _path72, _g34, _path73, _path74, _g35, _path75, _path76, _g36, _path77, _path78, _g37, _path79, _path80, _g38, _path81, _path82, _g39, _path83, _path84, _g40, _path85, _path86, _g41, _path87, _path88, _g42, _path89, _path90, _g43, _path91, _path92, _g44, _path93, _path94, _g45, _path95, _path96, _g46, _path97, _path98, _g47, _path99, _path100, _g48, _path101, _path102, _g49, _path103, _path104, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMulti1Desk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 489,
    viewBox: "0 0 500 489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 489,
    rx: 11.0223,
    fill: "#252525",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.551114,
    y: 0.551114,
    width: 498.898,
    height: 487.898,
    rx: 10.4712,
    stroke: "#757575",
    strokeOpacity: 0.1,
    strokeWidth: 1.10223
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.907 53.7402L214.14 52.3584H220.65L220.418 53.7402H217.991L216.907 60.2852H215.251L216.334 53.7402H213.907ZM220.406 60.2852L221.722 52.3584H223.398L222.856 55.629H226.258L226.8 52.3584H228.472L227.156 60.2852H225.484L226.026 57.0107H222.624L222.082 60.2852H220.406ZM228.538 60.2852L229.854 52.3584H235.195L234.963 53.7402H231.298L230.988 55.629H234.378L234.146 57.0107H230.756L230.446 58.9034H234.127L233.895 60.2852H228.538ZM243.053 55.1335H241.381C241.386 54.9116 241.358 54.7155 241.296 54.5452C241.234 54.3724 241.141 54.2253 241.017 54.104C240.896 53.9827 240.748 53.8911 240.572 53.8292C240.397 53.7647 240.199 53.7324 239.98 53.7324C239.557 53.7324 239.168 53.8382 238.815 54.0498C238.461 54.2614 238.163 54.5685 237.921 54.971C237.678 55.3709 237.511 55.8547 237.418 56.4224C237.327 56.9694 237.333 57.4275 237.433 57.7964C237.534 58.1654 237.712 58.4441 237.967 58.6325C238.225 58.8182 238.547 58.9111 238.931 58.9111C239.168 58.9111 239.394 58.8815 239.608 58.8221C239.823 58.7602 240.017 58.6725 240.193 58.5589C240.371 58.4428 240.526 58.3022 240.657 58.137C240.792 57.9719 240.896 57.7848 240.971 57.5758H242.654C242.549 57.9396 242.384 58.2906 242.159 58.6286C241.937 58.9666 241.662 59.2685 241.335 59.5343C241.007 59.7975 240.634 60.0065 240.216 60.1613C239.798 60.3161 239.34 60.3935 238.842 60.3935C238.122 60.3935 237.504 60.2284 236.988 59.8981C236.475 59.5678 236.104 59.0918 235.877 58.4699C235.65 57.848 235.608 57.0985 235.75 56.2212C235.891 55.3722 236.169 54.6523 236.582 54.0614C236.997 53.468 237.502 53.0177 238.095 52.7106C238.691 52.4036 239.328 52.25 240.007 52.25C240.479 52.25 240.906 52.3145 241.288 52.4436C241.67 52.5726 241.995 52.7609 242.264 53.0087C242.535 53.2538 242.738 53.5544 242.875 53.9105C243.012 54.2666 243.071 54.6743 243.053 55.1335ZM251.334 56.4302C251.19 57.2765 250.91 57.9951 250.494 58.586C250.081 59.1769 249.577 59.6259 248.981 59.9329C248.387 60.24 247.747 60.3935 247.061 60.3935C246.341 60.3935 245.721 60.2297 245.199 59.902C244.681 59.5743 244.305 59.1008 244.073 58.4815C243.841 57.8597 243.797 57.1101 243.941 56.2328C244.081 55.3838 244.358 54.6639 244.774 54.073C245.189 53.4796 245.696 53.028 246.295 52.7184C246.893 52.4061 247.537 52.25 248.226 52.25C248.941 52.25 249.557 52.4152 250.076 52.7455C250.597 53.0757 250.973 53.5531 251.202 54.1775C251.435 54.7994 251.479 55.5503 251.334 56.4302ZM249.666 56.2328C249.756 55.6883 249.752 55.2316 249.654 54.8626C249.559 54.491 249.383 54.2098 249.128 54.0188C248.872 53.8279 248.55 53.7324 248.16 53.7324C247.737 53.7324 247.349 53.8382 246.995 54.0498C246.644 54.2614 246.348 54.5685 246.105 54.971C245.865 55.3709 245.699 55.8573 245.606 56.4302C245.513 56.9772 245.515 57.4339 245.613 57.8003C245.714 58.1667 245.893 58.4441 246.151 58.6325C246.412 58.8182 246.736 58.9111 247.123 58.9111C247.544 58.9111 247.928 58.8079 248.276 58.6015C248.627 58.3925 248.923 58.0893 249.163 57.6919C249.403 57.292 249.57 56.8056 249.666 56.2328ZM254.925 52.3584L253.609 60.2852H251.933L253.249 52.3584H254.925ZM262.934 52.3584L261.618 60.2852H260.17L257.558 55.2961H257.496L256.664 60.2852H254.988L256.304 52.3584H257.775L260.375 57.3436H260.441L261.266 52.3584H262.934ZM263.003 60.2852L264.319 52.3584H267.446C268.045 52.3584 268.537 52.4642 268.924 52.6758C269.314 52.8874 269.588 53.188 269.745 53.5776C269.905 53.9647 269.942 54.4214 269.857 54.9478C269.769 55.4741 269.58 55.9257 269.288 56.3024C268.999 56.6792 268.623 56.9694 268.158 57.1733C267.696 57.3746 267.161 57.4752 266.552 57.4752H264.458L264.69 56.1283H266.509C266.829 56.1283 267.103 56.0844 267.33 55.9967C267.557 55.9089 267.736 55.7773 267.868 55.6019C268.002 55.4264 268.09 55.2084 268.131 54.9478C268.175 54.682 268.159 54.4601 268.085 54.282C268.01 54.1014 267.874 53.9647 267.678 53.8718C267.482 53.7763 267.224 53.7286 266.904 53.7286H265.774L264.678 60.2852H263.003ZM267.879 56.6779L269.253 60.2852H267.403L266.072 56.6779H267.879ZM273.211 52.3584L271.895 60.2852H270.219L271.535 52.3584H273.211ZM278.503 54.6613C278.516 54.3388 278.422 54.0898 278.22 53.9143C278.022 53.7389 277.721 53.6512 277.319 53.6512C277.045 53.6512 276.808 53.6899 276.606 53.7673C276.405 53.8421 276.244 53.9466 276.123 54.0808C276.004 54.2124 275.93 54.3646 275.902 54.5375C275.874 54.6794 275.883 54.8033 275.929 54.9091C275.978 55.0149 276.054 55.1065 276.157 55.1839C276.263 55.2587 276.388 55.3245 276.533 55.3813C276.677 55.4354 276.831 55.4819 276.993 55.5206L277.675 55.6909C278.007 55.7683 278.307 55.8715 278.573 56.0005C278.841 56.1296 279.065 56.2882 279.246 56.4766C279.429 56.665 279.558 56.8869 279.633 57.1423C279.708 57.3978 279.718 57.6906 279.664 58.0209C279.581 58.506 279.389 58.9266 279.087 59.2827C278.785 59.6362 278.389 59.911 277.899 60.1071C277.409 60.3006 276.841 60.3974 276.196 60.3974C275.556 60.3974 275.016 60.2993 274.574 60.1032C274.133 59.9071 273.812 59.6169 273.611 59.2324C273.412 58.8453 273.353 58.3667 273.433 57.7964H275.054C275.026 58.0622 275.065 58.2841 275.17 58.4622C275.279 58.6376 275.44 58.7705 275.654 58.8608C275.868 58.9486 276.12 58.9924 276.409 58.9924C276.695 58.9924 276.95 58.9511 277.171 58.8686C277.396 58.786 277.578 58.6712 277.717 58.5241C277.857 58.377 277.942 58.208 277.973 58.0171C278.004 57.839 277.976 57.6894 277.891 57.5681C277.806 57.4468 277.669 57.3436 277.481 57.2584C277.295 57.1707 277.064 57.0933 276.788 57.0262L275.96 56.8095C275.32 56.6469 274.836 56.3927 274.509 56.047C274.181 55.7012 274.063 55.2355 274.156 54.6497C274.239 54.1698 274.439 53.7505 274.756 53.3918C275.076 53.0306 275.479 52.7506 275.964 52.5519C276.452 52.3507 276.984 52.25 277.562 52.25C278.151 52.25 278.647 52.352 279.052 52.5558C279.458 52.7571 279.753 53.0383 279.939 53.3996C280.125 53.7608 280.181 54.1814 280.109 54.6613H278.503ZM280.416 60.2852L281.732 52.3584H287.073L286.841 53.7402H283.176L282.866 55.629H286.256L286.024 57.0107H282.634L282.324 58.9034H286.005L285.773 60.2852H280.416Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.147 86.5664L180.902 75.9974H184.772C185.522 75.9974 186.123 76.1213 186.574 76.369C187.028 76.6133 187.341 76.9453 187.513 77.365C187.685 77.7813 187.726 78.2509 187.637 78.7738C187.564 79.2142 187.422 79.5841 187.208 79.8834C186.998 80.1827 186.744 80.4235 186.444 80.6059C186.145 80.7882 185.83 80.9207 185.5 81.0032L185.479 81.1064C185.823 81.1237 186.145 81.2372 186.444 81.4471C186.747 81.6535 186.978 81.9476 187.136 82.3295C187.294 82.7114 187.33 83.1759 187.244 83.7229C187.152 84.263 186.942 84.7481 186.615 85.1782C186.291 85.6048 185.846 85.9437 185.278 86.1948C184.711 86.4426 184.017 86.5664 183.198 86.5664H179.147ZM180.969 85.1988H183.271C184.034 85.1988 184.606 85.0509 184.984 84.755C185.366 84.4591 185.596 84.0893 185.676 83.6455C185.727 83.3118 185.691 83.0056 185.567 82.7269C185.447 82.4482 185.244 82.2263 184.958 82.0612C184.676 81.896 184.322 81.8135 183.895 81.8135H181.537L180.969 85.1988ZM181.748 80.5697H183.88C184.237 80.5697 184.571 80.5009 184.881 80.3633C185.194 80.2257 185.454 80.0313 185.66 79.7802C185.87 79.529 186.001 79.2349 186.052 78.8977C186.128 78.4573 186.037 78.0909 185.779 77.7985C185.524 77.5026 185.082 77.3547 184.452 77.3547H182.275L181.748 80.5697ZM188.656 86.5664L190.41 75.9974H197.037L196.81 77.3701H191.778L191.241 80.5904H195.927L195.7 81.958H191.014L190.478 85.1937H195.571L195.344 86.5664H188.656ZM204.456 78.8358C204.46 78.3163 204.291 77.9189 203.951 77.6437C203.614 77.3684 203.142 77.2308 202.537 77.2308C202.103 77.2308 201.716 77.2996 201.376 77.4372C201.038 77.5714 200.763 77.7572 200.55 77.9946C200.34 78.2285 200.211 78.4952 200.163 78.7945C200.118 79.0456 200.14 79.2624 200.23 79.4447C200.323 79.6271 200.455 79.7802 200.627 79.904C200.803 80.0244 200.995 80.1259 201.205 80.2085C201.415 80.2876 201.618 80.353 201.814 80.4046L202.805 80.673C203.125 80.7555 203.45 80.8673 203.78 81.0084C204.111 81.1495 204.408 81.3352 204.673 81.5657C204.938 81.7963 205.136 82.0818 205.267 82.4224C205.397 82.763 205.423 83.1707 205.344 83.6455C205.241 84.2441 204.998 84.7757 204.616 85.2401C204.235 85.7046 203.73 86.071 203.104 86.3393C202.478 86.6077 201.752 86.7419 200.927 86.7419C200.135 86.7419 199.47 86.6163 198.929 86.3651C198.393 86.114 197.999 85.7579 197.748 85.2969C197.496 84.8324 197.407 84.282 197.479 83.6455H199.084C199.046 84.0274 199.115 84.3456 199.291 84.6002C199.47 84.8514 199.721 85.0389 200.044 85.1627C200.367 85.2831 200.734 85.3433 201.143 85.3433C201.597 85.3433 202.012 85.2728 202.387 85.1317C202.762 84.9873 203.072 84.7877 203.316 84.5331C203.56 84.2751 203.71 83.974 203.765 83.63C203.82 83.3169 203.775 83.0606 203.631 82.8611C203.49 82.6615 203.276 82.4964 202.991 82.3656C202.709 82.2349 202.387 82.1197 202.026 82.0199L200.834 81.6793C200.025 81.4488 199.413 81.1099 198.996 80.6626C198.58 80.2154 198.431 79.6236 198.547 78.8874C198.651 78.2784 198.905 77.7469 199.311 77.2927C199.717 76.8386 200.223 76.486 200.828 76.2348C201.434 75.9802 202.091 75.8529 202.8 75.8529C203.515 75.8529 204.124 75.9802 204.627 76.2348C205.129 76.4894 205.501 76.8403 205.741 77.2876C205.982 77.7348 206.067 78.2509 205.994 78.8358H204.456ZM207.771 77.3701L207.998 75.9974H216.178L215.95 77.3701H212.653L211.125 86.5664H209.536L211.063 77.3701H207.771ZM230.362 75.9974L228.607 86.5664H227.141L223.059 78.8151H222.966L221.671 86.5664H220.076L221.831 75.9974H223.307L227.394 83.759H227.492L228.782 75.9974H230.362ZM230.933 86.5664L232.688 75.9974H239.314L239.087 77.3701H234.055L233.519 80.5904H238.204L237.977 81.958H233.291L232.755 85.1937H237.848L237.621 86.5664H230.933ZM241.759 86.5664L240.582 75.9974H242.259L242.961 84.1822H243.059L246.558 75.9974H248.22L249.004 84.1874H249.108L252.514 75.9974H254.196L249.505 86.5664H247.9L246.997 78.65H246.914L243.369 86.5664H241.759ZM258.748 77.3701L258.975 75.9974H267.154L266.927 77.3701H263.63L262.102 86.5664H260.513L262.04 77.3701H258.748ZM267.207 86.5664L268.962 75.9974H272.729C273.548 75.9974 274.203 76.1385 274.695 76.4206C275.191 76.6993 275.531 77.088 275.717 77.5869C275.906 78.0823 275.948 78.6569 275.841 79.3105C275.731 79.9573 275.499 80.525 275.144 81.0136C274.793 81.5021 274.324 81.884 273.735 82.1592C273.151 82.431 272.449 82.5669 271.63 82.5669H268.776L269.013 81.1942H271.723C272.242 81.1942 272.676 81.1202 273.023 80.9723C273.371 80.8243 273.643 80.6093 273.839 80.3272C274.038 80.0451 274.169 79.7062 274.231 79.3105C274.296 78.908 274.277 78.5623 274.174 78.2733C274.071 77.9808 273.87 77.7572 273.57 77.6024C273.271 77.4441 272.86 77.365 272.337 77.365H270.335L268.802 86.5664H267.207ZM273.214 81.798L275.036 86.5664H273.219L271.444 81.798H273.214ZM277.509 86.5664H275.816L281.374 75.9974H283.217L285.266 86.5664H283.573L282.03 77.9172H281.947L277.509 86.5664ZM278.479 82.4276H283.97L283.743 83.7693H278.252L278.479 82.4276ZM290.26 86.5664H286.792L288.546 75.9974H292.03C293.069 75.9974 293.927 76.2142 294.605 76.6477C295.283 77.0777 295.758 77.6935 296.029 78.4952C296.301 79.2933 296.344 80.2481 296.158 81.3593C295.979 82.4465 295.629 83.3789 295.106 84.1564C294.586 84.9305 293.917 85.5257 293.098 85.942C292.279 86.3583 291.333 86.5664 290.26 86.5664ZM288.624 85.173H290.327C291.132 85.173 291.829 85.0165 292.417 84.7034C293.009 84.3903 293.489 83.9362 293.857 83.341C294.225 82.7458 294.479 82.0216 294.621 81.1684C294.758 80.3564 294.746 79.6701 294.584 79.1093C294.423 78.5451 294.11 78.1184 293.645 77.8294C293.181 77.537 292.563 77.3908 291.792 77.3908H289.909L288.624 85.173ZM300.629 75.9974L298.874 86.5664H297.28L299.034 75.9974H300.629ZM311.482 75.9974L309.727 86.5664H308.261L304.179 78.8151H304.086L302.791 86.5664H301.196L302.951 75.9974H304.427L308.514 83.759H308.612L309.902 75.9974H311.482ZM320.398 79.3364C320.353 79.0233 320.274 78.7429 320.161 78.4952C320.05 78.244 319.901 78.0307 319.712 77.8552C319.522 77.6798 319.295 77.5456 319.03 77.4527C318.765 77.3564 318.458 77.3082 318.107 77.3082C317.508 77.3082 316.935 77.4613 316.388 77.7675C315.845 78.0737 315.377 78.5227 314.984 79.1144C314.592 79.7028 314.326 80.4235 314.185 81.2768C314.04 82.1334 314.05 82.8576 314.215 83.4494C314.381 84.0411 314.673 84.4901 315.093 84.7963C315.513 85.1025 316.032 85.2556 316.651 85.2556C317.226 85.2556 317.754 85.1386 318.236 84.9047C318.717 84.6707 319.118 84.3405 319.438 83.9138C319.761 83.4838 319.97 82.978 320.062 82.3966L320.46 82.474H317.436L317.663 81.1581H321.822L321.611 82.3605C321.47 83.2516 321.157 84.0239 320.671 84.6776C320.186 85.3279 319.583 85.8302 318.86 86.1845C318.141 86.5354 317.353 86.7109 316.496 86.7109C315.54 86.7109 314.738 86.4907 314.092 86.0503C313.445 85.61 312.987 84.9855 312.719 84.177C312.454 83.3651 312.414 82.4018 312.6 81.2871C312.734 80.4442 312.973 79.6873 313.318 79.0164C313.665 78.3455 314.09 77.7761 314.592 77.3082C315.095 76.8369 315.654 76.4774 316.269 76.2296C316.889 75.9785 317.539 75.8529 318.22 75.8529C318.791 75.8529 319.309 75.9372 319.773 76.1058C320.241 76.2744 320.644 76.5135 320.981 76.8231C321.318 77.1328 321.578 77.5009 321.76 77.9275C321.943 78.3507 322.034 78.8203 322.034 79.3364H320.398ZM209.851 104.566L211.606 93.9974H215.373C216.192 93.9974 216.846 94.1471 217.334 94.4464C217.826 94.7457 218.163 95.1534 218.346 95.6695C218.531 96.1855 218.571 96.7687 218.464 97.4189C218.354 98.0692 218.12 98.654 217.762 99.1735C217.408 99.6896 216.935 100.099 216.343 100.402C215.752 100.701 215.048 100.851 214.233 100.851H211.637L211.859 99.4987H214.305C214.824 99.4987 215.261 99.4092 215.616 99.2303C215.973 99.048 216.254 98.8003 216.457 98.4872C216.66 98.1707 216.792 97.8146 216.854 97.4189C216.92 97.0164 216.902 96.662 216.803 96.3558C216.703 96.0462 216.505 95.8036 216.209 95.6282C215.917 95.4527 215.507 95.365 214.981 95.365H212.979L211.446 104.566H209.851ZM219.118 104.566L220.873 93.9974H222.468L220.94 103.194H225.729L225.502 104.566H219.118ZM228.753 104.566H227.061L232.619 93.9974H234.461L236.51 104.566H234.817L233.274 95.9172H233.192L228.753 104.566ZM229.724 100.428H235.214L234.987 101.769H229.496L229.724 100.428ZM237.793 95.3701L238.021 93.9974H246.2L245.973 95.3701H242.675L241.148 104.566H239.558L241.086 95.3701H237.793ZM246.253 104.566L248.008 93.9974H254.562L254.335 95.3701H249.375L248.839 98.5904H253.328L253.101 99.958H248.611L247.848 104.566H246.253ZM264.811 99.3851C264.625 100.496 264.264 101.449 263.727 102.244C263.194 103.039 262.54 103.65 261.766 104.076C260.995 104.499 260.163 104.711 259.268 104.711C258.336 104.711 257.539 104.489 256.879 104.045C256.222 103.598 255.75 102.963 255.465 102.141C255.179 101.315 255.131 100.331 255.32 99.189C255.506 98.0778 255.866 97.1248 256.399 96.33C256.936 95.5318 257.591 94.9195 258.365 94.4928C259.143 94.0662 259.982 93.8529 260.883 93.8529C261.809 93.8529 262.599 94.0765 263.252 94.5238C263.909 94.9676 264.381 95.6041 264.666 96.4332C264.952 97.2589 265 98.2429 264.811 99.3851ZM263.257 99.189C263.398 98.3461 263.381 97.6374 263.206 97.0628C263.034 96.4848 262.74 96.0479 262.323 95.752C261.907 95.4562 261.405 95.3082 260.816 95.3082C260.19 95.3082 259.604 95.4665 259.057 95.783C258.513 96.0995 258.049 96.5605 257.663 97.166C257.278 97.7716 257.015 98.5113 256.874 99.3851C256.729 100.228 256.745 100.937 256.92 101.511C257.096 102.086 257.391 102.521 257.808 102.817C258.227 103.109 258.732 103.256 259.32 103.256C259.943 103.256 260.526 103.099 261.069 102.786C261.616 102.469 262.082 102.01 262.468 101.408C262.853 100.803 263.116 100.063 263.257 99.189ZM265.937 104.566L267.692 93.9974H271.459C272.278 93.9974 272.933 94.1385 273.425 94.4206C273.921 94.6993 274.261 95.088 274.447 95.5869C274.636 96.0823 274.677 96.6569 274.571 97.3105C274.461 97.9573 274.228 98.525 273.874 99.0136C273.523 99.5021 273.054 99.884 272.465 100.159C271.88 100.431 271.179 100.567 270.36 100.567H267.506L267.743 99.1942H270.453C270.972 99.1942 271.406 99.1202 271.753 98.9723C272.101 98.8243 272.372 98.6093 272.568 98.3272C272.768 98.0451 272.899 97.7062 272.961 97.3105C273.026 96.908 273.007 96.5623 272.904 96.2733C272.801 95.9808 272.599 95.7572 272.3 95.6024C272.001 95.4441 271.59 95.365 271.067 95.365H269.064L267.532 104.566H265.937ZM271.944 99.798L273.766 104.566H271.949L270.174 99.798H271.944ZM277.101 93.9974H279.036L281.049 102.213H281.173L285.889 93.9974H287.825L286.07 104.566H284.553L285.827 96.9183H285.729L281.343 104.551H280.078L278.241 96.9132H278.143L276.863 104.566H275.346L277.101 93.9974ZM232.79 121.566L232.991 120.41L237.171 116.705C237.618 116.303 237.992 115.95 238.291 115.647C238.594 115.341 238.829 115.05 238.998 114.775C239.17 114.5 239.283 114.207 239.338 113.898C239.397 113.547 239.366 113.244 239.246 112.989C239.129 112.731 238.941 112.534 238.683 112.396C238.425 112.255 238.115 112.184 237.754 112.184C237.376 112.184 237.032 112.262 236.722 112.417C236.412 112.571 236.154 112.79 235.948 113.072C235.742 113.354 235.606 113.684 235.54 114.063H234.023C234.13 113.419 234.374 112.857 234.756 112.375C235.138 111.894 235.611 111.52 236.175 111.255C236.739 110.987 237.35 110.853 238.007 110.853C238.674 110.853 239.237 110.985 239.695 111.25C240.156 111.512 240.489 111.87 240.696 112.324C240.902 112.774 240.957 113.284 240.861 113.851C240.792 114.247 240.653 114.632 240.443 115.007C240.233 115.379 239.91 115.795 239.473 116.256C239.036 116.714 238.441 117.269 237.687 117.923L235.231 120.121L235.215 120.199H239.968L239.746 121.566H232.79ZM245.356 121.742C244.54 121.742 243.88 121.529 243.374 121.102C242.868 120.672 242.531 120.049 242.363 119.234C242.194 118.418 242.203 117.436 242.388 116.287C242.578 115.141 242.892 114.163 243.333 113.351C243.777 112.539 244.322 111.919 244.969 111.493C245.619 111.066 246.348 110.853 247.157 110.853C247.962 110.853 248.619 111.068 249.128 111.498C249.637 111.925 249.98 112.542 250.155 113.351C250.334 114.159 250.327 115.138 250.135 116.287C249.942 117.44 249.625 118.422 249.185 119.234C248.745 120.046 248.199 120.667 247.549 121.097C246.899 121.527 246.168 121.742 245.356 121.742ZM245.583 120.364C246.302 120.364 246.921 120.015 247.441 119.316C247.96 118.618 248.33 117.608 248.55 116.287C248.695 115.41 248.724 114.668 248.638 114.063C248.555 113.454 248.368 112.993 248.075 112.68C247.786 112.363 247.405 112.205 246.93 112.205C246.221 112.205 245.605 112.558 245.082 113.263C244.563 113.965 244.195 114.973 243.978 116.287C243.83 117.168 243.797 117.913 243.88 118.522C243.962 119.127 244.148 119.586 244.437 119.9C244.726 120.209 245.108 120.364 245.583 120.364ZM251.083 121.566L251.284 120.41L255.464 116.705C255.911 116.303 256.285 115.95 256.584 115.647C256.887 115.341 257.122 115.05 257.291 114.775C257.463 114.5 257.577 114.207 257.632 113.898C257.69 113.547 257.659 113.244 257.539 112.989C257.422 112.731 257.234 112.534 256.976 112.396C256.718 112.255 256.409 112.184 256.047 112.184C255.669 112.184 255.325 112.262 255.015 112.417C254.706 112.571 254.448 112.79 254.241 113.072C254.035 113.354 253.899 113.684 253.833 114.063H252.316C252.423 113.419 252.667 112.857 253.049 112.375C253.431 111.894 253.904 111.52 254.468 111.255C255.032 110.987 255.643 110.853 256.3 110.853C256.968 110.853 257.53 110.985 257.988 111.25C258.449 111.512 258.782 111.87 258.989 112.324C259.195 112.774 259.25 113.284 259.154 113.851C259.085 114.247 258.946 114.632 258.736 115.007C258.526 115.379 258.203 115.795 257.766 116.256C257.329 116.714 256.734 117.269 255.98 117.923L253.524 120.121L253.508 120.199H258.261L258.039 121.566H251.083ZM263.463 121.711C262.816 121.711 262.256 121.585 261.781 121.334C261.306 121.083 260.952 120.739 260.718 120.302C260.484 119.865 260.403 119.368 260.475 118.811H262.023C261.989 119.261 262.13 119.635 262.447 119.93C262.763 120.223 263.174 120.369 263.68 120.369C264.086 120.369 264.463 120.276 264.81 120.09C265.158 119.901 265.448 119.643 265.682 119.316C265.92 118.986 266.074 118.608 266.147 118.181C266.216 117.751 266.185 117.367 266.054 117.03C265.923 116.693 265.711 116.428 265.419 116.235C265.127 116.039 264.769 115.941 264.346 115.941C264.029 115.941 263.701 115.998 263.36 116.112C263.019 116.222 262.732 116.364 262.498 116.54L261.074 116.323L262.555 110.997H268.366L268.144 112.365H263.659L262.828 115.322H262.89C263.135 115.119 263.437 114.952 263.799 114.821C264.16 114.687 264.538 114.62 264.934 114.62C265.577 114.62 266.126 114.773 266.58 115.079C267.034 115.386 267.361 115.804 267.561 116.334C267.764 116.863 267.807 117.469 267.69 118.15C267.58 118.835 267.325 119.445 266.926 119.982C266.527 120.519 266.028 120.942 265.429 121.252C264.831 121.558 264.175 121.711 263.463 121.711Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 320,
    y: 123,
    width: 35,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.344 123.34H354.788V153.291H320.344V123.34Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 320,
    y: 123,
    width: 35,
    height: 31
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M329.836 148.436C331.663 143.123 334.756 129.949 323.339 123.594C323.339 123.594 314.609 143.347 328.6 150.558C341.677 159.304 354.755 142.111 354.755 142.111C343.666 135.208 333.606 144.271 329.836 148.436Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.756 123.594V159.304H314.609V123.594H354.756Z",
    fill: "url(#paint0_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 134,
    width: 34,
    height: 33
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M308.859 134.324H341.806V166.772H308.859V134.324Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 134,
    width: 34,
    height: 33
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.975 160.398C318.826 155.558 324.508 143.252 314.594 134.742C314.594 134.742 302.078 152.345 314.333 162.208C325.393 173.404 341.656 159.173 341.656 159.173C332.181 150.178 320.503 157.071 315.975 160.398Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.672 134.742V173.402H302.094V134.742H341.672Z",
    fill: "url(#paint1_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 328,
    y: 112,
    width: 34,
    height: 26
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M328.844 112.359H361.291V137.319H328.844V112.359Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 329,
    y: 112,
    width: 33,
    height: 26
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M339.825 133.962C340.628 128.911 341.334 116.582 330.088 112.672C330.088 112.672 325.354 131.772 339.045 136.046C352.156 141.824 361.192 124.364 361.192 124.364C350.156 119.898 342.553 129.633 339.825 133.962Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.19 112.672V141.824H325.352V112.672H361.19Z",
    fill: "url(#paint2_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 334,
    y: 100,
    width: 33,
    height: 23
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M334.32 100.879H366.269V122.344H334.32V100.879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 334,
    y: 101,
    width: 33,
    height: 22
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M347.554 119.611C347.472 114.683 346.086 102.884 334.776 101.047C334.776 101.047 333.469 119.94 347.154 121.713C360.551 125.03 366.2 106.951 366.2 106.951C354.995 104.531 349.414 115.022 347.554 119.611Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.207 101.047V125.03H333.477V101.047H366.207Z",
    fill: "url(#paint3_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 337,
    y: 87,
    width: 31,
    height: 20
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M337.312 87.3984H367.759V106.867H337.312V87.3984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 337,
    y: 87,
    width: 31,
    height: 20
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M350.957 104.539C350.559 99.8828 348.459 88.7952 337.625 87.7852C337.625 87.7852 337.625 105.764 350.721 106.538C363.63 108.814 367.781 91.3029 367.781 91.3029C357.012 89.7956 352.419 100.101 350.957 104.539Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.781 87.7852V108.814H337.625V87.7852H367.781Z",
    fill: "url(#paint4_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 337,
    y: 74,
    width: 27,
    height: 17
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M337.312 74.4219H363.77V90.8953H337.312V74.4219Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 337,
    y: 74,
    width: 27,
    height: 17
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M351.833 88.7078C350.676 84.8877 346.913 75.9958 337.68 77.1171C337.68 77.1171 340.928 92.1397 352 90.4413C363.193 90.0006 363.517 74.6328 363.517 74.6328C354.237 75.2919 352.254 84.7317 351.833 88.7078Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.517 74.6328V92.1397H337.68V74.6328H363.517Z",
    fill: "url(#paint5_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 336,
    y: 61,
    width: 24,
    height: 17
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M336.367 61.4453H359.33V77.9187H336.367V61.4453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 336,
    y: 61,
    width: 24,
    height: 17
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M350.413 75.5773C348.933 72.3189 344.604 64.8486 336.539 66.9116C336.539 66.9116 341.129 79.8868 350.766 77.1198C360.658 75.4681 359.202 61.7812 359.202 61.7812C351.027 63.3978 350.339 72.0011 350.413 75.5773Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.658 61.7812V79.8868H336.539V61.7812H360.658Z",
    fill: "url(#paint6_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 334,
    y: 51,
    width: 20,
    height: 16
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M334.844 51.457H353.314V66.4329H334.844V51.457Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 334,
    y: 51,
    width: 20,
    height: 16
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M347.248 64.199C345.651 61.7381 341.228 56.2274 334.938 58.8677C334.938 58.8677 340.251 68.8107 347.716 65.3845C355.52 62.8359 352.665 51.9336 352.665 51.9336C346.253 54.2619 346.75 61.311 347.248 64.199Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.52 51.9336V68.8107H334.938V51.9336H355.52Z",
    fill: "url(#paint7_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 331,
    y: 42,
    width: 18,
    height: 15
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M331.32 42.4766H348.792V56.9532H331.32V42.4766Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 331,
    y: 42,
    width: 18,
    height: 15
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M343.545 54.7833C341.811 52.6637 337.048 47.9954 331.461 51.1485C331.461 51.1485 337.516 59.8552 344.112 55.8402C351.119 52.5993 347.258 42.7305 347.258 42.7305C341.538 45.6086 342.783 52.143 343.545 54.7833Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.119 42.7305V59.8552H331.461V42.7305H351.119Z",
    fill: "url(#paint8_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 326,
    y: 34,
    width: 17,
    height: 15
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M326.836 34.4883H342.81V48.9649H326.836V34.4883Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 327,
    y: 34,
    width: 16,
    height: 15
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M338.854 46.4949C336.994 44.6931 332.09 40.8048 327.188 44.3226C327.188 44.3226 333.728 51.8339 339.492 47.425C345.718 43.6869 341.104 34.8477 341.104 34.8477C336.035 38.1178 337.854 44.1042 338.854 46.4949Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.718 34.8477V51.8339H327.188V34.8477H345.718Z",
    fill: "url(#paint9_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 324,
    y: 29,
    width: 13,
    height: 13
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M324.344 29.9922H336.824V41.9728H324.344V29.9922Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 324,
    y: 30,
    width: 13,
    height: 12
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M333.915 39.5359C332.271 38.3795 328.045 35.9011 324.664 39.1712C324.664 39.1712 330.561 44.2509 334.492 40.1832C338.879 36.5953 334.318 30.2852 334.318 30.2852C330.785 33.3837 332.868 37.8023 333.915 39.5359Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.879 30.2852V44.2509H324.664V30.2852H338.879Z",
    fill: "url(#paint10_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 317,
    y: 26,
    width: 15,
    height: 10
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M317.875 26H331.353V35.9839H317.875V26Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 318,
    y: 26,
    width: 13,
    height: 10
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M330.839 35.8774C330.839 35.8774 323.681 37.5057 318.195 26.1061C318.195 26.1061 327.573 24.4252 330.839 35.8774Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.839 24.4219V37.5023H318.195V24.4219H330.839Z",
    fill: "url(#paint11_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 123,
    width: 36,
    height: 31
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M179.43 123.344H144.985V153.295H179.43V123.344Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 123,
    width: 35,
    height: 31
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M169.945 148.444C168.118 143.131 165.025 129.957 176.442 123.602C176.442 123.602 185.172 143.355 171.181 150.566C158.105 159.311 145.026 142.119 145.026 142.119C156.116 135.216 166.176 144.279 169.945 148.444Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.002 123.602V159.312H185.148V123.602H145.002Z",
    fill: "url(#paint12_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 134,
    width: 34,
    height: 33
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M190.898 134.324H157.952V166.772H190.898V134.324Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 134,
    width: 33,
    height: 33
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M183.775 160.398C180.924 155.558 175.242 143.252 185.156 134.742C185.156 134.742 197.672 152.345 185.417 162.208C174.357 173.404 158.094 159.173 158.094 159.173C167.569 150.178 179.247 157.071 183.775 160.398Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.078 134.742V173.402H197.656V134.742H158.078Z",
    fill: "url(#paint13_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 112,
    width: 33,
    height: 26
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M170.922 112.359H138.474V137.319H170.922V112.359Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 112,
    width: 33,
    height: 26
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M159.957 133.962C159.153 128.911 158.447 116.582 169.693 112.672C169.693 112.672 174.427 131.772 160.737 136.046C147.625 141.824 138.589 124.364 138.589 124.364C149.626 119.898 157.229 129.633 159.957 133.962Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.599 112.672V141.824H174.438V112.672H138.599Z",
    fill: "url(#paint14_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 100,
    width: 33,
    height: 23
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M165.43 100.879H133.481V122.344H165.43V100.879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 101,
    width: 33,
    height: 22
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M152.204 119.611C152.286 114.683 153.672 102.884 164.982 101.047C164.982 101.047 166.289 119.94 152.604 121.713C139.207 125.03 133.558 106.951 133.558 106.951C144.763 104.531 150.344 115.022 152.204 119.611Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.559 101.047V125.03H166.289V101.047H133.559Z",
    fill: "url(#paint15_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 87,
    width: 31,
    height: 20
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M162.453 87.3984H132.006V106.867H162.453V87.3984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 87,
    width: 32,
    height: 20
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M148.801 104.543C149.199 99.8867 151.299 88.7992 162.133 87.7891C162.133 87.7891 162.133 105.768 149.037 106.542C136.128 108.818 131.976 91.3068 131.976 91.3068C142.746 89.7995 147.338 100.105 148.801 104.543Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.976 87.7891V108.818H162.133V87.7891H131.976Z",
    fill: "url(#paint16_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 74,
    width: 28,
    height: 17
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M162.453 74.4219H135.996V90.8953H162.453V74.4219Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 136,
    y: 74,
    width: 27,
    height: 17
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M147.917 88.7078C149.074 84.8877 152.837 75.9958 162.07 77.1171C162.07 77.1171 158.822 92.1397 147.75 90.4413C136.557 90.0006 136.233 74.6328 136.233 74.6328C145.513 75.2919 147.496 84.7317 147.917 88.7078Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.233 74.6328V92.1397H162.07V74.6328H136.233Z",
    fill: "url(#paint17_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 61,
    width: 24,
    height: 17
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M163.422 61.4453H140.459V77.9187H163.422V61.4453Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 61,
    width: 24,
    height: 17
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M149.352 75.5773C150.833 72.3189 155.161 64.8486 163.227 66.9116C163.227 66.9116 158.636 79.8868 149 77.1198C139.107 75.4681 140.564 61.7812 140.564 61.7812C148.738 63.3978 149.427 72.0011 149.352 75.5773Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.107 61.7812V79.8868H163.227V61.7812H139.107Z",
    fill: "url(#paint18_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 51,
    width: 19,
    height: 16
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M164.898 51.457H146.428V66.4329H164.898V51.457Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 51,
    width: 19,
    height: 16
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M152.494 64.195C154.092 61.7342 158.514 56.2235 164.805 58.8638C164.805 58.8638 159.491 68.8067 152.026 65.3806C144.223 62.832 147.077 51.9297 147.077 51.9297C153.489 54.258 152.992 61.3071 152.494 64.195Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.223 51.9297V68.8067H164.805V51.9297H144.223Z",
    fill: "url(#paint19_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 42,
    width: 19,
    height: 15
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M168.43 42.4766H150.958V56.9532H168.43V42.4766Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 151,
    y: 42,
    width: 18,
    height: 15
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M156.228 54.7833C157.962 52.6637 162.726 47.9954 168.312 51.1485C168.312 51.1485 162.258 59.8552 155.661 55.8402C148.655 52.5993 152.516 42.7305 152.516 42.7305C158.235 45.6086 156.991 52.143 156.228 54.7833Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.655 42.7305V59.8552H168.312V42.7305H148.655Z",
    fill: "url(#paint20_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 34,
    width: 17,
    height: 15
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M172.93 34.4883H156.955V48.9649H172.93V34.4883Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 34,
    width: 16,
    height: 15
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M160.904 46.4949C162.764 44.6931 167.668 40.8048 172.57 44.3226C172.57 44.3226 166.03 51.8339 160.266 47.425C154.04 43.6869 158.653 34.8477 158.653 34.8477C163.723 38.1178 161.904 44.1042 160.904 46.4949Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.04 34.8477V51.8339H172.57V34.8477H154.04Z",
    fill: "url(#paint21_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 29,
    width: 14,
    height: 13
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M175.406 29.9922H162.926V41.9728H175.406V29.9922Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 30,
    width: 13,
    height: 12
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M165.859 39.5359C167.503 38.3795 171.728 35.9011 175.109 39.1712C175.109 39.1712 169.213 44.2509 165.281 40.1832C160.894 36.5953 165.455 30.2852 165.455 30.2852C168.988 33.3837 166.906 37.8023 165.859 39.5359Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.894 30.2852V44.2509H175.109V30.2852H160.894Z",
    fill: "url(#paint22_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 26,
    width: 14,
    height: 10
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M181.875 26H168.397V35.9839H181.875V26Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 26,
    width: 14,
    height: 10
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M168.888 35.8774C168.888 35.8774 176.046 37.5057 181.531 26.1061C181.531 26.1061 172.154 24.4252 168.888 35.8774Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.888 24.4219V37.5023H181.531V24.4219H168.888Z",
    fill: "url(#paint23_linear_1660_8859)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 227,
    y: 130,
    width: 46,
    height: 43
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M227.984 130.07H272.413V172.502H227.984V130.07Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 228,
    y: 130,
    width: 45,
    height: 43
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M250.258 130.57L257.028 144.275L272.166 146.468L261.209 157.141L263.792 172.202L250.258 165.091L236.719 172.202L239.303 157.141L228.352 146.468L243.489 144.275L250.258 130.57Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.469 130.57V172.202H272.283V130.57H228.469Z",
    fill: "url(#paint24_linear_1660_8859)"
  })))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M252.565 330.52L254.417 334.27L258.559 334.87L255.561 337.79L256.268 341.912L252.565 339.966L248.86 341.912L249.567 337.79L246.57 334.87L250.713 334.27L252.565 330.52Z",
    fill: "#7C7C7C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 199,
    width: 125.705,
    height: 289.921,
    fill: "url(#pattern0_1660_8859)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M237.902 318.469L238.382 315.577H239.441C239.647 315.577 239.811 315.611 239.934 315.678C240.058 315.745 240.144 315.836 240.191 315.951C240.238 316.065 240.25 316.193 240.225 316.336C240.205 316.457 240.166 316.558 240.108 316.64C240.05 316.722 239.981 316.788 239.899 316.838C239.817 316.888 239.731 316.924 239.641 316.946L239.635 316.975C239.729 316.979 239.817 317.01 239.899 317.068C239.982 317.124 240.045 317.205 240.088 317.309C240.131 317.414 240.141 317.541 240.118 317.691C240.092 317.838 240.035 317.971 239.946 318.089C239.857 318.206 239.735 318.298 239.58 318.367C239.424 318.435 239.235 318.469 239.011 318.469H237.902ZM238.401 318.095H239.03C239.239 318.095 239.396 318.054 239.499 317.973C239.604 317.892 239.667 317.791 239.689 317.669C239.703 317.578 239.693 317.494 239.659 317.418C239.626 317.342 239.57 317.281 239.492 317.236C239.415 317.191 239.318 317.168 239.201 317.168H238.556L238.401 318.095ZM238.614 316.828H239.197C239.295 316.828 239.386 316.809 239.471 316.771C239.557 316.734 239.628 316.681 239.684 316.612C239.742 316.543 239.777 316.463 239.792 316.37C239.812 316.25 239.787 316.15 239.717 316.07C239.647 315.989 239.526 315.948 239.354 315.948H238.758L238.614 316.828ZM240.504 318.469L240.984 315.577H242.797L242.735 315.952H241.358L241.212 316.833H242.494L242.432 317.208H241.149L241.003 318.093H242.396L242.334 318.469H240.504ZM244.828 316.353C244.829 316.211 244.782 316.102 244.689 316.027C244.597 315.952 244.468 315.914 244.302 315.914C244.184 315.914 244.078 315.933 243.985 315.971C243.892 316.007 243.817 316.058 243.759 316.123C243.701 316.187 243.666 316.26 243.653 316.342C243.641 316.411 243.647 316.47 243.671 316.52C243.697 316.57 243.733 316.612 243.78 316.646C243.828 316.679 243.881 316.706 243.938 316.729C243.995 316.751 244.051 316.769 244.105 316.783L244.376 316.856C244.463 316.879 244.552 316.909 244.643 316.948C244.733 316.986 244.814 317.037 244.887 317.1C244.959 317.163 245.014 317.242 245.049 317.335C245.085 317.428 245.092 317.54 245.071 317.669C245.042 317.833 244.976 317.979 244.871 318.106C244.767 318.233 244.629 318.333 244.458 318.407C244.286 318.48 244.088 318.517 243.862 318.517C243.645 318.517 243.463 318.482 243.315 318.414C243.168 318.345 243.061 318.248 242.992 318.121C242.923 317.994 242.899 317.844 242.918 317.669H243.358C243.347 317.774 243.366 317.861 243.414 317.931C243.463 317.999 243.532 318.051 243.62 318.085C243.709 318.118 243.809 318.134 243.921 318.134C244.045 318.134 244.159 318.115 244.261 318.076C244.364 318.037 244.449 317.982 244.516 317.912C244.582 317.842 244.623 317.759 244.638 317.665C244.653 317.58 244.641 317.509 244.602 317.455C244.563 317.4 244.505 317.355 244.427 317.319C244.349 317.283 244.261 317.252 244.163 317.225L243.836 317.131C243.615 317.068 243.448 316.976 243.334 316.853C243.22 316.731 243.179 316.569 243.211 316.367C243.239 316.201 243.309 316.055 243.42 315.931C243.531 315.807 243.669 315.71 243.835 315.642C244.001 315.572 244.18 315.537 244.374 315.537C244.57 315.537 244.737 315.572 244.874 315.642C245.012 315.711 245.113 315.807 245.179 315.93C245.245 316.052 245.268 316.193 245.248 316.353H244.828ZM245.735 315.952L245.797 315.577H248.035L247.973 315.952H247.07L246.652 318.469H246.218L246.636 315.952H245.735ZM249.377 315.952L249.439 315.577H251.678L251.615 315.952H250.713L250.295 318.469H249.86L250.278 315.952H249.377ZM251.692 318.469L252.172 315.577H253.203C253.427 315.577 253.606 315.615 253.741 315.692C253.877 315.769 253.97 315.875 254.021 316.012C254.072 316.147 254.084 316.304 254.055 316.483C254.024 316.66 253.961 316.816 253.864 316.949C253.768 317.083 253.639 317.187 253.478 317.263C253.318 317.337 253.126 317.374 252.902 317.374H252.121L252.186 316.999H252.928C253.07 316.999 253.188 316.978 253.284 316.938C253.379 316.898 253.453 316.839 253.507 316.761C253.561 316.684 253.597 316.592 253.614 316.483C253.632 316.373 253.627 316.279 253.598 316.199C253.57 316.119 253.515 316.058 253.433 316.016C253.351 315.973 253.239 315.951 253.096 315.951H252.548L252.128 318.469H251.692ZM253.336 317.164L253.834 318.469H253.337L252.851 317.164H253.336ZM254.511 318.469H254.048L255.569 315.577H256.073L256.633 318.469H256.17L255.748 316.102H255.725L254.511 318.469ZM254.777 317.336H256.279L256.217 317.703H254.714L254.777 317.336ZM258 318.469H257.051L257.531 315.577H258.484C258.769 315.577 259.004 315.636 259.189 315.755C259.375 315.872 259.504 316.041 259.579 316.26C259.653 316.479 259.665 316.74 259.614 317.044C259.565 317.341 259.469 317.597 259.326 317.809C259.184 318.021 259.001 318.184 258.777 318.298C258.553 318.412 258.294 318.469 258 318.469ZM257.552 318.087H258.018C258.239 318.087 258.429 318.045 258.59 317.959C258.752 317.873 258.884 317.749 258.984 317.586C259.085 317.423 259.155 317.225 259.193 316.992C259.231 316.769 259.228 316.582 259.183 316.428C259.139 316.274 259.054 316.157 258.926 316.078C258.799 315.998 258.63 315.958 258.419 315.958H257.904L257.552 318.087ZM260.837 315.577L260.357 318.469H259.921L260.401 315.577H260.837ZM263.807 315.577L263.327 318.469H262.926L261.809 316.348H261.784L261.429 318.469H260.993L261.473 315.577H261.877L262.995 317.701H263.022L263.375 315.577H263.807ZM266.247 316.49C266.235 316.405 266.213 316.328 266.182 316.26C266.152 316.191 266.111 316.133 266.059 316.085C266.007 316.037 265.945 316 265.873 315.975C265.8 315.949 265.716 315.935 265.62 315.935C265.456 315.935 265.299 315.977 265.15 316.061C265.001 316.145 264.873 316.268 264.766 316.43C264.658 316.591 264.585 316.788 264.547 317.021C264.507 317.256 264.51 317.454 264.555 317.616C264.6 317.778 264.68 317.901 264.795 317.984C264.91 318.068 265.052 318.11 265.222 318.11C265.379 318.11 265.523 318.078 265.655 318.014C265.787 317.95 265.897 317.86 265.984 317.743C266.073 317.625 266.13 317.487 266.155 317.328L266.264 317.349H265.436L265.499 316.989H266.637L266.579 317.318C266.54 317.562 266.455 317.773 266.322 317.952C266.189 318.13 266.024 318.267 265.826 318.364C265.629 318.46 265.414 318.508 265.179 318.508C264.918 318.508 264.698 318.448 264.521 318.328C264.344 318.207 264.219 318.036 264.146 317.815C264.073 317.593 264.062 317.329 264.113 317.024C264.15 316.793 264.215 316.586 264.31 316.403C264.405 316.219 264.521 316.063 264.658 315.935C264.796 315.806 264.949 315.708 265.117 315.64C265.287 315.572 265.465 315.537 265.651 315.537C265.807 315.537 265.949 315.56 266.076 315.606C266.204 315.652 266.314 315.718 266.407 315.803C266.499 315.887 266.57 315.988 266.62 316.105C266.67 316.221 266.695 316.349 266.695 316.49H266.247ZM241.151 323.469L241.631 320.577H242.662C242.886 320.577 243.065 320.618 243.198 320.7C243.333 320.781 243.425 320.893 243.475 321.034C243.526 321.175 243.537 321.335 243.507 321.513C243.477 321.691 243.413 321.851 243.315 321.993C243.218 322.134 243.089 322.246 242.927 322.329C242.765 322.411 242.573 322.452 242.35 322.452H241.639L241.7 322.082H242.369C242.511 322.082 242.631 322.058 242.728 322.009C242.826 321.959 242.903 321.891 242.958 321.805C243.014 321.719 243.05 321.621 243.067 321.513C243.085 321.403 243.08 321.306 243.053 321.222C243.025 321.137 242.971 321.071 242.89 321.023C242.81 320.975 242.698 320.951 242.554 320.951H242.006L241.587 323.469H241.151ZM243.686 323.469L244.167 320.577H244.603L244.185 323.093H245.495L245.433 323.469H243.686ZM246.323 323.469H245.86L247.381 320.577H247.885L248.445 323.469H247.982L247.56 321.102H247.537L246.323 323.469ZM246.588 322.336H248.091L248.029 322.703H246.526L246.588 322.336ZM248.797 320.952L248.859 320.577H251.097L251.035 320.952H250.133L249.715 323.469H249.28L249.698 320.952H248.797ZM251.111 323.469L251.592 320.577H253.385L253.323 320.952H251.966L251.819 321.833H253.048L252.985 322.208H251.757L251.548 323.469H251.111ZM256.19 322.051C256.139 322.355 256.04 322.616 255.893 322.833C255.747 323.051 255.568 323.218 255.356 323.335C255.145 323.45 254.918 323.508 254.673 323.508C254.418 323.508 254.2 323.448 254.019 323.326C253.839 323.204 253.71 323.03 253.632 322.805C253.554 322.579 253.541 322.31 253.593 321.997C253.643 321.693 253.742 321.432 253.888 321.215C254.035 320.997 254.214 320.829 254.426 320.712C254.639 320.596 254.868 320.537 255.115 320.537C255.368 320.537 255.584 320.598 255.763 320.721C255.943 320.842 256.072 321.016 256.15 321.243C256.228 321.469 256.241 321.738 256.19 322.051ZM255.764 321.997C255.803 321.767 255.798 321.573 255.75 321.416C255.703 321.257 255.623 321.138 255.509 321.057C255.395 320.976 255.258 320.935 255.097 320.935C254.925 320.935 254.765 320.979 254.615 321.065C254.466 321.152 254.339 321.278 254.234 321.444C254.128 321.609 254.056 321.812 254.018 322.051C253.978 322.282 253.982 322.476 254.03 322.633C254.078 322.79 254.159 322.909 254.273 322.99C254.388 323.07 254.526 323.11 254.687 323.11C254.857 323.11 255.017 323.067 255.166 322.982C255.315 322.895 255.443 322.769 255.548 322.605C255.654 322.439 255.726 322.236 255.764 321.997ZM256.498 323.469L256.978 320.577H258.009C258.233 320.577 258.412 320.615 258.547 320.692C258.682 320.769 258.776 320.875 258.826 321.012C258.878 321.147 258.889 321.304 258.86 321.483C258.83 321.66 258.767 321.816 258.67 321.949C258.574 322.083 258.445 322.187 258.284 322.263C258.124 322.337 257.932 322.374 257.708 322.374H256.927L256.992 321.999H257.733C257.876 321.999 257.994 321.978 258.089 321.938C258.184 321.898 258.259 321.839 258.312 321.761C258.367 321.684 258.403 321.592 258.42 321.483C258.438 321.373 258.432 321.279 258.404 321.199C258.376 321.119 258.321 321.058 258.239 321.016C258.157 320.973 258.044 320.951 257.901 320.951H257.353L256.934 323.469H256.498ZM258.141 322.164L258.64 323.469H258.143L257.657 322.164H258.141ZM259.553 320.577H260.082L260.633 322.825H260.667L261.957 320.577H262.487L262.007 323.469H261.592L261.94 321.376H261.914L260.713 323.465H260.367L259.865 321.375H259.838L259.488 323.469H259.072L259.553 320.577ZM247.427 328.469L247.482 328.152L248.626 327.139C248.749 327.028 248.851 326.932 248.933 326.849C249.016 326.765 249.08 326.686 249.126 326.61C249.173 326.535 249.204 326.455 249.219 326.37C249.235 326.274 249.227 326.191 249.194 326.122C249.162 326.051 249.111 325.997 249.04 325.959C248.969 325.921 248.885 325.901 248.786 325.901C248.682 325.901 248.588 325.923 248.503 325.965C248.419 326.007 248.348 326.067 248.292 326.144C248.235 326.222 248.198 326.312 248.18 326.416H247.765C247.794 326.239 247.861 326.086 247.965 325.954C248.07 325.822 248.199 325.72 248.354 325.647C248.508 325.574 248.675 325.537 248.855 325.537C249.038 325.537 249.192 325.573 249.317 325.646C249.443 325.717 249.534 325.815 249.591 325.94C249.647 326.063 249.662 326.202 249.636 326.358C249.617 326.466 249.579 326.571 249.522 326.674C249.464 326.776 249.376 326.89 249.256 327.016C249.137 327.141 248.974 327.293 248.768 327.472L248.095 328.073L248.091 328.095H249.392L249.331 328.469H247.427ZM250.866 328.517C250.643 328.517 250.462 328.458 250.324 328.342C250.185 328.224 250.093 328.054 250.047 327.83C250.001 327.607 250.003 327.339 250.054 327.024C250.106 326.711 250.192 326.443 250.312 326.221C250.434 325.998 250.583 325.829 250.76 325.712C250.938 325.596 251.138 325.537 251.359 325.537C251.579 325.537 251.759 325.596 251.898 325.714C252.038 325.83 252.131 325.999 252.179 326.221C252.228 326.442 252.226 326.71 252.174 327.024C252.121 327.34 252.034 327.608 251.914 327.83C251.793 328.053 251.644 328.223 251.466 328.34C251.288 328.458 251.088 328.517 250.866 328.517ZM250.928 328.14C251.125 328.14 251.294 328.044 251.436 327.853C251.579 327.662 251.68 327.386 251.74 327.024C251.78 326.784 251.788 326.581 251.764 326.416C251.741 326.249 251.69 326.123 251.61 326.037C251.531 325.95 251.427 325.907 251.297 325.907C251.103 325.907 250.934 326.004 250.791 326.197C250.649 326.389 250.548 326.665 250.489 327.024C250.448 327.265 250.439 327.469 250.462 327.636C250.485 327.801 250.536 327.927 250.615 328.013C250.694 328.097 250.798 328.14 250.928 328.14ZM252.433 328.469L252.488 328.152L253.632 327.139C253.754 327.028 253.857 326.932 253.938 326.849C254.021 326.765 254.086 326.686 254.132 326.61C254.179 326.535 254.21 326.455 254.225 326.37C254.241 326.274 254.233 326.191 254.2 326.122C254.168 326.051 254.116 325.997 254.046 325.959C253.975 325.921 253.89 325.901 253.792 325.901C253.688 325.901 253.594 325.923 253.509 325.965C253.424 326.007 253.354 326.067 253.297 326.144C253.241 326.222 253.204 326.312 253.186 326.416H252.771C252.8 326.239 252.867 326.086 252.971 325.954C253.076 325.822 253.205 325.72 253.359 325.647C253.514 325.574 253.681 325.537 253.861 325.537C254.043 325.537 254.197 325.573 254.323 325.646C254.449 325.717 254.54 325.815 254.596 325.94C254.653 326.063 254.668 326.202 254.642 326.358C254.623 326.466 254.585 326.571 254.527 326.674C254.47 326.776 254.381 326.89 254.262 327.016C254.142 327.141 253.979 327.293 253.773 327.472L253.101 328.073L253.097 328.095H254.397L254.337 328.469H252.433ZM255.821 328.508C255.644 328.508 255.49 328.474 255.36 328.405C255.231 328.336 255.134 328.242 255.07 328.123C255.006 328.003 254.983 327.867 255.003 327.715H255.427C255.417 327.838 255.456 327.94 255.543 328.021C255.629 328.101 255.742 328.141 255.88 328.141C255.991 328.141 256.094 328.116 256.189 328.065C256.284 328.013 256.364 327.942 256.428 327.853C256.493 327.763 256.535 327.659 256.555 327.542C256.574 327.425 256.565 327.32 256.53 327.227C256.494 327.135 256.436 327.063 256.356 327.01C256.276 326.956 256.178 326.93 256.062 326.93C255.976 326.93 255.886 326.945 255.793 326.976C255.699 327.006 255.621 327.045 255.557 327.093L255.167 327.034L255.572 325.577H257.162L257.102 325.951H255.874L255.647 326.76H255.664C255.731 326.705 255.814 326.659 255.913 326.623C256.011 326.586 256.115 326.568 256.223 326.568C256.399 326.568 256.549 326.61 256.674 326.694C256.798 326.777 256.887 326.892 256.942 327.037C256.998 327.182 257.009 327.348 256.977 327.534C256.947 327.721 256.878 327.888 256.768 328.035C256.659 328.182 256.523 328.298 256.359 328.383C256.195 328.466 256.016 328.508 255.821 328.508Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 328,
    width: 10,
    height: 10
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M271.398 328.82H280.824V337.016H271.398V328.82Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 328,
    width: 10,
    height: 9
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M273.959 335.685C274.459 334.231 275.306 330.626 272.182 328.887C272.182 328.887 269.793 334.292 273.621 336.265C277.199 338.658 280.778 333.954 280.778 333.954C277.744 332.065 274.991 334.545 273.959 335.685Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.79 328.887V338.658H269.805V328.887H280.79Z",
    fill: "#7C7C7C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 268,
    y: 331,
    width: 10,
    height: 10
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M268.25 331.82H277.265V340.699H268.25V331.82Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 268,
    y: 331,
    width: 10,
    height: 10
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M270.179 338.966C270.959 337.641 272.514 334.274 269.801 331.945C269.801 331.945 266.376 336.762 269.73 339.461C272.756 342.525 277.207 338.631 277.207 338.631C274.614 336.169 271.418 338.055 270.179 338.966Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.236 331.945V342.524H266.406V331.945H277.236Z",
    fill: "#7C7C7C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 273,
    y: 325,
    width: 10,
    height: 8
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M273.727 325.812H282.605V332.642H273.727V325.812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 273,
    y: 325,
    width: 10,
    height: 8
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M276.74 331.724C276.96 330.342 277.153 326.968 274.076 325.898C274.076 325.898 272.78 331.125 276.527 332.295C280.115 333.876 282.587 329.098 282.587 329.098C279.567 327.876 277.487 330.54 276.74 331.724Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.58 325.898V333.876H272.773V325.898H282.58Z",
    fill: "#9C9C9C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 322,
    width: 9,
    height: 7
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M275.211 322.676H283.953V328.549H275.211V322.676Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 322,
    width: 9,
    height: 7
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M278.826 327.802C278.804 326.454 278.424 323.225 275.33 322.723C275.33 322.723 274.972 327.893 278.717 328.378C282.382 329.285 283.928 324.338 283.928 324.338C280.862 323.676 279.335 326.547 278.826 327.802Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.917 322.723V329.285H274.961V322.723H283.917Z",
    fill: "#969696"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 276,
    y: 318,
    width: 9,
    height: 7
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M276.055 318.984H284.386V324.312H276.055V318.984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 276,
    y: 319,
    width: 9,
    height: 6
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M279.812 323.678C279.703 322.404 279.129 319.37 276.164 319.094C276.164 319.094 276.164 324.013 279.748 324.225C283.28 324.848 284.416 320.056 284.416 320.056C281.469 319.644 280.212 322.464 279.812 323.678Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.416 319.094V324.848H276.164V319.094H284.416Z",
    fill: "#B0B0B0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 276,
    y: 315,
    width: 8,
    height: 5
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M276.055 315.426H283.294V319.934H276.055V315.426Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 276,
    y: 315,
    width: 8,
    height: 5
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M280.037 319.328C279.72 318.283 278.691 315.85 276.164 316.156C276.164 316.156 277.053 320.267 280.083 319.802C283.145 319.682 283.234 315.477 283.234 315.477C280.695 315.657 280.152 318.24 280.037 319.328Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.234 315.477V320.267H276.164V315.477H283.234Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 311,
    width: 8,
    height: 6
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M275.781 311.879H282.065V316.387H275.781V311.879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 311,
    width: 8,
    height: 6
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M279.648 315.744C279.243 314.852 278.058 312.808 275.852 313.373C275.852 313.373 277.108 316.923 279.745 316.166C282.451 315.714 282.053 311.969 282.053 311.969C279.816 312.411 279.628 314.765 279.648 315.744Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.451 311.969V316.923H275.852V311.969H282.451Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 309,
    width: 6,
    height: 5
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M275.336 309.148H280.39V313.246H275.336V309.148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 309,
    width: 6,
    height: 5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M278.751 312.634C278.314 311.96 277.104 310.452 275.383 311.175C275.383 311.175 276.837 313.896 278.879 312.958C281.015 312.261 280.234 309.277 280.234 309.277C278.479 309.914 278.615 311.843 278.751 312.634Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.015 309.277V313.896H275.383V309.277H281.015Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 274,
    y: 306,
    width: 6,
    height: 5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M274.406 306.691H279.187V310.653H274.406V306.691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 274,
    y: 306,
    width: 6,
    height: 5
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M277.736 310.064C277.262 309.484 275.958 308.206 274.43 309.069C274.43 309.069 276.086 311.452 277.892 310.353C279.809 309.466 278.752 306.766 278.752 306.766C277.187 307.553 277.528 309.341 277.736 310.064Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.809 306.766V311.452H274.43V306.766H279.809Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 273,
    y: 304,
    width: 5,
    height: 5
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M273.148 304.508H277.52V308.469H273.148V304.508Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 273,
    y: 304,
    width: 5,
    height: 5
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M276.458 307.789C275.949 307.296 274.607 306.232 273.266 307.194C273.266 307.194 275.055 309.25 276.633 308.043C278.336 307.02 277.074 304.602 277.074 304.602C275.686 305.496 276.184 307.134 276.458 307.789Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.336 304.602V309.25H273.266V304.602H278.336Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 272,
    y: 303,
    width: 4,
    height: 4
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M272.484 303.273H275.899V306.552H272.484V303.273Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask71_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 272,
    y: 303,
    width: 4,
    height: 4
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M275.078 305.887C274.628 305.57 273.472 304.892 272.547 305.787C272.547 305.787 274.16 307.177 275.236 306.064C276.437 305.082 275.189 303.355 275.189 303.355C274.222 304.203 274.792 305.412 275.078 305.887Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.437 303.355V307.177H272.547V303.355H276.437Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 270,
    y: 302,
    width: 5,
    height: 3
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M270.711 302.184H274.399V304.916H270.711V302.184Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask73_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 270,
    y: 302,
    width: 5,
    height: 3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M274.28 304.885C274.28 304.885 272.321 305.331 270.82 302.211C270.82 302.211 273.386 301.751 274.28 304.885Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.28 301.75V305.329H270.82V301.75H274.28Z",
    fill: "#D6D6D6"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 328,
    width: 10,
    height: 10
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M232.562 328.82H223.137V337.016H232.562V328.82Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask75_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 328,
    width: 10,
    height: 9
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M230.001 335.685C229.502 334.231 228.655 330.626 231.779 328.887C231.779 328.887 234.168 334.292 230.34 336.265C226.762 338.658 223.183 333.954 223.183 333.954C226.217 332.065 228.97 334.545 230.001 335.685Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.163 328.887V338.658H234.148V328.887H223.163Z",
    fill: "#7C7C7C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 226,
    y: 331,
    width: 10,
    height: 10
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M235.703 331.82H226.688V340.699H235.703V331.82Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask77_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 226,
    y: 331,
    width: 10,
    height: 10
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M233.789 338.966C233.009 337.641 231.455 334.274 234.167 331.945C234.167 331.945 237.592 336.762 234.239 339.461C231.212 342.525 226.762 338.631 226.762 338.631C229.355 336.169 232.551 338.055 233.789 338.966Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.732 331.945V342.524H237.562V331.945H226.732Z",
    fill: "#7C7C7C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 221,
    y: 325,
    width: 10,
    height: 8
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M230.227 325.812H221.348V332.642H230.227V325.812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask79_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 221,
    y: 325,
    width: 10,
    height: 8
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M227.205 331.724C226.985 330.342 226.792 326.968 229.869 325.898C229.869 325.898 231.165 331.125 227.419 332.295C223.831 333.876 221.358 329.098 221.358 329.098C224.378 327.876 226.459 330.54 227.205 331.724Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.365 325.898V333.876H231.172V325.898H221.365Z",
    fill: "#9C9C9C"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 322,
    width: 9,
    height: 7
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M228.742 322.676H220V328.549H228.742V322.676Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask81_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 322,
    width: 9,
    height: 7
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M225.135 327.802C225.157 326.454 225.537 323.225 228.631 322.723C228.631 322.723 228.989 327.893 225.244 328.378C221.579 329.285 220.033 324.338 220.033 324.338C223.099 323.676 224.626 326.547 225.135 327.802Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.044 322.723V329.285H229V322.723H220.044Z",
    fill: "#969696"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 219,
    y: 318,
    width: 9,
    height: 7
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M227.914 318.984H219.583V324.312H227.914V318.984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask83_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 219,
    y: 319,
    width: 9,
    height: 6
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M224.188 323.678C224.297 322.404 224.871 319.37 227.836 319.094C227.836 319.094 227.836 324.013 224.252 324.225C220.72 324.848 219.584 320.056 219.584 320.056C222.531 319.644 223.788 322.464 224.188 323.678Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.584 319.094V324.848H227.836V319.094H219.584Z",
    fill: "#B0B0B0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 315,
    width: 8,
    height: 5
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M227.914 315.426H220.674V319.934H227.914V315.426Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask85_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 315,
    width: 8,
    height: 5
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M223.963 319.328C224.28 318.283 225.309 315.85 227.836 316.156C227.836 316.156 226.947 320.267 223.917 319.802C220.855 319.682 220.766 315.477 220.766 315.477C223.305 315.657 223.848 318.24 223.963 319.328Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.766 315.477V320.267H227.836V315.477H220.766Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 221,
    y: 311,
    width: 8,
    height: 6
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M228.188 311.879H221.904V316.387H228.188V311.879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask87_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 221,
    y: 311,
    width: 8,
    height: 6
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M224.321 315.744C224.726 314.852 225.91 312.808 228.117 313.373C228.117 313.373 226.861 316.923 224.224 316.166C221.517 315.714 221.916 311.969 221.916 311.969C224.153 312.411 224.341 314.765 224.321 315.744Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.517 311.969V316.923H228.117V311.969H221.517Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 309,
    width: 6,
    height: 5
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M228.617 309.148H223.563V313.246H228.617V309.148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask89_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 223,
    y: 309,
    width: 6,
    height: 5
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M225.21 312.634C225.647 311.96 226.857 310.452 228.578 311.175C228.578 311.175 227.124 313.896 225.082 312.958C222.946 312.261 223.727 309.277 223.727 309.277C225.482 309.914 225.346 311.843 225.21 312.634Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.946 309.277V313.896H228.578V309.277H222.946Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 306,
    width: 6,
    height: 5
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M229.555 306.691H224.774V310.653H229.555V306.691Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask91_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 306,
    width: 6,
    height: 5
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M226.217 310.064C226.691 309.484 227.995 308.206 229.523 309.069C229.523 309.069 227.867 311.452 226.062 310.353C224.144 309.466 225.201 306.766 225.201 306.766C226.766 307.553 226.425 309.341 226.217 310.064Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.144 306.766V311.452H229.523V306.766H224.144Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 226,
    y: 304,
    width: 5,
    height: 5
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M230.812 304.508H226.441V308.469H230.812V304.508Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask93_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 226,
    y: 304,
    width: 5,
    height: 5
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M227.518 307.789C228.028 307.296 229.37 306.232 230.711 307.194C230.711 307.194 228.921 309.25 227.344 308.043C225.64 307.02 226.903 304.602 226.903 304.602C228.29 305.496 227.792 307.134 227.518 307.789Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.64 304.602V309.25H230.711V304.602H225.64Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 228,
    y: 303,
    width: 4,
    height: 4
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M231.477 303.273H228.062V306.552H231.477V303.273Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask95_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 228,
    y: 303,
    width: 4,
    height: 4
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M228.859 305.887C229.309 305.57 230.465 304.892 231.391 305.787C231.391 305.787 229.777 307.177 228.701 306.064C227.501 305.082 228.749 303.355 228.749 303.355C229.716 304.203 229.146 305.412 228.859 305.887Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.501 303.355V307.177H231.391V303.355H227.501Z",
    fill: "#C0C0C0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 302,
    width: 5,
    height: 3
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M233.273 302.184H229.585V304.916H233.273V302.184Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_1660_8859)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask97_1660_8859",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 302,
    width: 5,
    height: 3
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M229.673 304.885C229.673 304.885 231.632 305.331 233.133 302.211C233.133 302.211 230.567 301.751 229.673 304.885Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_1660_8859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.673 301.75V305.329H233.133V301.75H229.673Z",
    fill: "#D6D6D6"
  })))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M233.843 309.485L233.961 308.779H237.287L237.168 309.485H235.928L235.375 312.828H234.529L235.082 309.485H233.843ZM237.162 312.828L237.834 308.779H238.69L238.413 310.45H240.151L240.428 308.779H241.282L240.61 312.828H239.756L240.033 311.156H238.295L238.018 312.828H237.162ZM241.316 312.828L241.988 308.779H244.716L244.597 309.485H242.725L242.567 310.45H244.299L244.18 311.156H242.449L242.29 312.122H244.17L244.052 312.828H241.316ZM248.73 310.197H247.876C247.878 310.083 247.864 309.983 247.832 309.896C247.801 309.808 247.753 309.733 247.69 309.671C247.628 309.609 247.552 309.562 247.463 309.53C247.373 309.498 247.272 309.481 247.16 309.481C246.944 309.481 246.746 309.535 246.565 309.643C246.385 309.751 246.232 309.908 246.108 310.114C245.985 310.318 245.899 310.565 245.851 310.855C245.805 311.134 245.808 311.368 245.859 311.557C245.911 311.745 246.002 311.888 246.132 311.984C246.264 312.079 246.428 312.126 246.624 312.126C246.746 312.126 246.861 312.111 246.97 312.081C247.08 312.049 247.179 312.004 247.269 311.946C247.36 311.887 247.439 311.815 247.506 311.731C247.575 311.647 247.628 311.551 247.666 311.444H248.526C248.472 311.63 248.388 311.809 248.273 311.982C248.16 312.155 248.02 312.309 247.852 312.445C247.685 312.579 247.494 312.686 247.281 312.765C247.067 312.844 246.833 312.883 246.579 312.883C246.211 312.883 245.896 312.799 245.632 312.63C245.37 312.462 245.181 312.219 245.065 311.901C244.949 311.583 244.927 311.2 244.999 310.752C245.072 310.319 245.213 309.951 245.424 309.649C245.637 309.346 245.894 309.116 246.197 308.959C246.502 308.802 246.827 308.724 247.174 308.724C247.415 308.724 247.633 308.757 247.828 308.823C248.023 308.889 248.19 308.985 248.327 309.111C248.465 309.237 248.569 309.39 248.639 309.572C248.709 309.754 248.739 309.962 248.73 310.197ZM252.96 310.859C252.886 311.291 252.743 311.658 252.531 311.96C252.32 312.262 252.062 312.491 251.758 312.648C251.455 312.805 251.128 312.883 250.777 312.883C250.409 312.883 250.092 312.8 249.826 312.632C249.561 312.465 249.369 312.223 249.251 311.907C249.132 311.589 249.11 311.206 249.184 310.758C249.255 310.325 249.396 309.957 249.609 309.655C249.821 309.352 250.08 309.121 250.386 308.963C250.691 308.804 251.02 308.724 251.372 308.724C251.737 308.724 252.052 308.808 252.317 308.977C252.583 309.146 252.775 309.389 252.892 309.708C253.011 310.026 253.033 310.41 252.96 310.859ZM252.108 310.758C252.154 310.48 252.152 310.247 252.102 310.058C252.053 309.869 251.963 309.725 251.833 309.627C251.702 309.53 251.538 309.481 251.339 309.481C251.122 309.481 250.924 309.535 250.743 309.643C250.564 309.751 250.413 309.908 250.289 310.114C250.166 310.318 250.081 310.566 250.034 310.859C249.986 311.138 249.988 311.372 250.038 311.559C250.089 311.746 250.181 311.888 250.312 311.984C250.446 312.079 250.611 312.126 250.809 312.126C251.024 312.126 251.22 312.074 251.398 311.968C251.577 311.861 251.728 311.707 251.851 311.504C251.973 311.299 252.059 311.051 252.108 310.758ZM254.794 308.779L254.122 312.828H253.266L253.938 308.779H254.794ZM258.885 308.779L258.213 312.828H257.473L256.139 310.28H256.107L255.682 312.828H254.826L255.498 308.779H256.249L257.578 311.326H257.612L258.033 308.779H258.885ZM258.92 312.828L259.592 308.779H261.189C261.495 308.779 261.747 308.833 261.945 308.941C262.144 309.049 262.283 309.203 262.364 309.402C262.445 309.6 262.465 309.833 262.421 310.102C262.376 310.371 262.279 310.601 262.13 310.794C261.983 310.986 261.79 311.134 261.553 311.239C261.317 311.341 261.044 311.393 260.733 311.393H259.663L259.782 310.705H260.711C260.874 310.705 261.014 310.682 261.13 310.638C261.246 310.593 261.338 310.526 261.405 310.436C261.473 310.346 261.518 310.235 261.539 310.102C261.562 309.966 261.554 309.853 261.516 309.762C261.477 309.67 261.408 309.6 261.308 309.552C261.208 309.503 261.076 309.479 260.913 309.479H260.335L259.776 312.828H258.92ZM261.411 310.986L262.113 312.828H261.168L260.488 310.986H261.411ZM264.134 308.779L263.462 312.828H262.606L263.278 308.779H264.134ZM266.837 309.956C266.844 309.791 266.796 309.664 266.693 309.574C266.591 309.484 266.438 309.44 266.232 309.44C266.093 309.44 265.971 309.459 265.868 309.499C265.766 309.537 265.683 309.59 265.621 309.659C265.561 309.726 265.523 309.804 265.509 309.892C265.494 309.965 265.499 310.028 265.522 310.082C265.548 310.136 265.586 310.183 265.639 310.222C265.693 310.261 265.757 310.294 265.831 310.323C265.905 310.351 265.983 310.375 266.066 310.394L266.414 310.481C266.584 310.521 266.737 310.574 266.873 310.64C267.01 310.705 267.125 310.787 267.217 310.883C267.31 310.979 267.376 311.092 267.414 311.223C267.453 311.353 267.458 311.503 267.43 311.672C267.388 311.919 267.29 312.134 267.136 312.316C266.982 312.497 266.779 312.637 266.529 312.737C266.278 312.836 265.988 312.885 265.659 312.885C265.332 312.885 265.056 312.835 264.831 312.735C264.605 312.635 264.441 312.487 264.338 312.29C264.237 312.093 264.206 311.848 264.247 311.557H265.076C265.061 311.693 265.081 311.806 265.135 311.897C265.19 311.987 265.273 312.054 265.382 312.101C265.492 312.145 265.62 312.168 265.768 312.168C265.914 312.168 266.044 312.147 266.157 312.105C266.272 312.062 266.365 312.004 266.436 311.929C266.507 311.853 266.551 311.767 266.566 311.67C266.582 311.579 266.568 311.502 266.525 311.44C266.481 311.378 266.411 311.326 266.315 311.282C266.22 311.237 266.102 311.198 265.961 311.163L265.538 311.053C265.211 310.97 264.964 310.84 264.797 310.663C264.63 310.487 264.57 310.249 264.617 309.95C264.659 309.704 264.761 309.49 264.923 309.307C265.087 309.123 265.293 308.98 265.54 308.878C265.789 308.775 266.062 308.724 266.357 308.724C266.657 308.724 266.911 308.776 267.118 308.88C267.325 308.983 267.476 309.127 267.571 309.311C267.666 309.496 267.695 309.71 267.658 309.956H266.837ZM267.814 312.828L268.487 308.779H271.215L271.096 309.485H269.224L269.066 310.45H270.798L270.679 311.156H268.947L268.789 312.122H270.669L270.55 312.828H267.814Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M231.676 431.07L232.401 426.702H234.15C234.472 426.702 234.732 426.75 234.931 426.845C235.131 426.941 235.271 427.073 235.351 427.242C235.431 427.41 235.452 427.603 235.415 427.822C235.385 427.993 235.325 428.142 235.234 428.27C235.144 428.398 235.033 428.503 234.901 428.586C234.769 428.668 234.625 428.726 234.47 428.761L234.462 428.803C234.627 428.81 234.775 428.857 234.907 428.944C235.04 429.029 235.138 429.15 235.204 429.307C235.269 429.463 235.284 429.648 235.249 429.863C235.21 430.095 235.119 430.302 234.973 430.484C234.828 430.664 234.635 430.807 234.393 430.912C234.153 431.018 233.869 431.07 233.542 431.07H231.676ZM232.728 430.315H233.481C233.736 430.315 233.932 430.266 234.067 430.166C234.202 430.066 234.283 429.935 234.31 429.771C234.329 429.651 234.317 429.544 234.274 429.452C234.233 429.359 234.162 429.287 234.063 429.234C233.965 429.181 233.84 429.155 233.69 429.155H232.918L232.728 430.315ZM233.024 428.53H233.709C233.834 428.53 233.95 428.508 234.056 428.464C234.164 428.419 234.253 428.355 234.323 428.272C234.394 428.188 234.439 428.089 234.457 427.976C234.483 427.816 234.447 427.689 234.351 427.594C234.255 427.497 234.106 427.449 233.903 427.449H233.203L233.024 428.53ZM237.264 426.702L236.538 431.07H235.63L236.355 426.702H237.264ZM238.751 431.134C238.416 431.134 238.14 431.063 237.921 430.921C237.702 430.777 237.548 430.578 237.458 430.324C237.37 430.068 237.354 429.77 237.409 429.43C237.463 429.095 237.575 428.801 237.746 428.549C237.917 428.298 238.134 428.102 238.397 427.963C238.66 427.822 238.956 427.752 239.286 427.752C239.619 427.752 239.894 427.824 240.113 427.967C240.332 428.109 240.487 428.308 240.576 428.564C240.666 428.82 240.683 429.118 240.627 429.458C240.572 429.792 240.458 430.085 240.286 430.337C240.114 430.588 239.897 430.785 239.636 430.925C239.374 431.065 239.079 431.134 238.751 431.134ZM238.84 430.43C238.994 430.43 239.13 430.387 239.248 430.3C239.367 430.212 239.466 430.093 239.544 429.942C239.624 429.79 239.679 429.618 239.71 429.426C239.742 429.237 239.744 429.069 239.717 428.923C239.69 428.775 239.633 428.658 239.546 428.573C239.461 428.488 239.344 428.445 239.194 428.445C239.041 428.445 238.904 428.489 238.785 428.577C238.665 428.664 238.566 428.783 238.488 428.935C238.41 429.088 238.355 429.26 238.324 429.454C238.294 429.641 238.292 429.809 238.318 429.957C238.343 430.103 238.399 430.219 238.486 430.305C238.573 430.389 238.691 430.43 238.84 430.43ZM242.421 431.134C242.084 431.134 241.807 431.063 241.589 430.921C241.373 430.777 241.222 430.578 241.135 430.324C241.05 430.069 241.035 429.776 241.09 429.445C241.144 429.11 241.257 428.815 241.429 428.562C241.601 428.308 241.82 428.109 242.084 427.967C242.35 427.824 242.649 427.752 242.98 427.752C243.266 427.752 243.507 427.804 243.705 427.907C243.903 428.011 244.048 428.157 244.14 428.345C244.233 428.532 244.264 428.753 244.234 429.006H243.379C243.38 428.844 243.338 428.712 243.253 428.611C243.168 428.51 243.042 428.46 242.878 428.46C242.735 428.46 242.605 428.498 242.485 428.575C242.367 428.65 242.267 428.761 242.184 428.906C242.103 429.051 242.046 429.226 242.014 429.432C241.98 429.641 241.979 429.819 242.012 429.966C242.044 430.112 242.107 430.224 242.199 430.3C242.292 430.377 242.408 430.416 242.549 430.416C242.654 430.416 242.752 430.394 242.841 430.352C242.932 430.309 243.012 430.247 243.08 430.166C243.148 430.084 243.201 429.985 243.238 429.87H244.095C244.037 430.121 243.931 430.342 243.778 430.531C243.625 430.72 243.434 430.868 243.204 430.974C242.973 431.081 242.713 431.134 242.421 431.134ZM245.453 430.128L245.635 429.038H245.767L247.027 427.794H248.07L246.39 429.441H246.172L245.453 430.128ZM244.474 431.07L245.2 426.702H246.108L245.383 431.07H244.474ZM246.522 431.07L245.797 429.643L246.507 429.002L247.586 431.07H246.522ZM249.307 431.134C248.97 431.134 248.692 431.063 248.475 430.921C248.259 430.777 248.107 430.578 248.021 430.324C247.935 430.069 247.92 429.776 247.976 429.445C248.03 429.11 248.143 428.815 248.315 428.562C248.487 428.308 248.705 428.109 248.97 427.967C249.236 427.824 249.534 427.752 249.866 427.752C250.151 427.752 250.393 427.804 250.591 427.907C250.788 428.011 250.933 428.157 251.026 428.345C251.118 428.532 251.149 428.753 251.12 429.006H250.264C250.266 428.844 250.224 428.712 250.138 428.611C250.053 428.51 249.928 428.46 249.763 428.46C249.621 428.46 249.49 428.498 249.371 428.575C249.253 428.65 249.152 428.761 249.07 428.906C248.989 429.051 248.932 429.226 248.899 429.432C248.865 429.641 248.865 429.819 248.897 429.966C248.93 430.112 248.992 430.224 249.085 430.3C249.177 430.377 249.294 430.416 249.435 430.416C249.54 430.416 249.637 430.394 249.727 430.352C249.818 430.309 249.897 430.247 249.966 430.166C250.034 430.084 250.087 429.985 250.124 429.87H250.981C250.923 430.121 250.817 430.342 250.663 430.531C250.511 430.72 250.32 430.868 250.089 430.974C249.859 431.081 249.598 431.134 249.307 431.134ZM252.589 429.176L252.273 431.07H251.366L252.092 426.702H252.972L252.699 428.372H252.736C252.841 428.179 252.985 428.028 253.169 427.918C253.352 427.807 253.569 427.752 253.819 427.752C254.047 427.752 254.236 427.801 254.389 427.901C254.542 427.999 254.651 428.141 254.715 428.325C254.779 428.509 254.79 428.729 254.747 428.984L254.397 431.07H253.491L253.811 429.147C253.843 428.945 253.817 428.788 253.732 428.675C253.648 428.563 253.514 428.507 253.331 428.507C253.207 428.507 253.093 428.533 252.989 428.586C252.886 428.638 252.798 428.715 252.727 428.816C252.657 428.916 252.611 429.036 252.589 429.176ZM256.033 431.132C255.826 431.132 255.646 431.096 255.494 431.023C255.343 430.949 255.232 430.84 255.161 430.695C255.09 430.55 255.072 430.37 255.108 430.155C255.139 429.973 255.198 429.821 255.285 429.699C255.373 429.575 255.48 429.476 255.607 429.4C255.733 429.325 255.873 429.267 256.027 429.228C256.182 429.188 256.342 429.161 256.507 429.147C256.697 429.127 256.852 429.107 256.972 429.089C257.093 429.07 257.183 429.044 257.243 429.01C257.302 428.975 257.339 428.922 257.351 428.852V428.839C257.373 428.706 257.348 428.602 257.277 428.528C257.207 428.453 257.096 428.415 256.942 428.415C256.78 428.415 256.642 428.451 256.528 428.522C256.416 428.593 256.336 428.683 256.287 428.793L255.46 428.724C255.534 428.525 255.645 428.353 255.795 428.208C255.945 428.062 256.127 427.949 256.338 427.871C256.55 427.792 256.788 427.752 257.051 427.752C257.233 427.752 257.403 427.773 257.561 427.816C257.72 427.858 257.857 427.924 257.972 428.014C258.089 428.104 258.173 428.219 258.224 428.36C258.276 428.499 258.287 428.666 258.256 428.861L257.887 431.07H257.025L257.102 430.616H257.076C257.007 430.718 256.921 430.809 256.82 430.887C256.719 430.964 256.604 431.024 256.473 431.068C256.342 431.111 256.196 431.132 256.033 431.132ZM256.398 430.505C256.53 430.505 256.652 430.479 256.763 430.426C256.875 430.372 256.968 430.3 257.04 430.209C257.114 430.118 257.161 430.015 257.181 429.899L257.236 429.552C257.208 429.57 257.167 429.587 257.113 429.601C257.06 429.615 257.002 429.629 256.94 429.641C256.879 429.653 256.817 429.663 256.754 429.673C256.692 429.682 256.636 429.69 256.586 429.699C256.476 429.715 256.378 429.739 256.292 429.774C256.205 429.808 256.134 429.854 256.08 429.912C256.026 429.969 255.993 430.04 255.98 430.125C255.96 430.249 255.989 430.344 256.068 430.409C256.147 430.473 256.257 430.505 256.398 430.505ZM258.592 431.07L259.138 427.794H260.046L259.5 431.07H258.592ZM259.686 427.368C259.551 427.368 259.439 427.323 259.351 427.233C259.264 427.142 259.229 427.034 259.244 426.909C259.26 426.781 259.321 426.673 259.428 426.585C259.534 426.496 259.655 426.451 259.79 426.451C259.925 426.451 260.036 426.496 260.121 426.585C260.206 426.673 260.242 426.781 260.228 426.909C260.213 427.034 260.153 427.142 260.046 427.233C259.941 427.323 259.821 427.368 259.686 427.368ZM261.457 429.176L261.141 431.07H260.234L260.78 427.794H261.644L261.55 428.372H261.587C261.69 428.18 261.837 428.029 262.026 427.918C262.217 427.807 262.433 427.752 262.676 427.752C262.904 427.752 263.094 427.801 263.246 427.901C263.399 428.001 263.508 428.142 263.57 428.325C263.634 428.509 263.645 428.729 263.602 428.984L263.252 431.07H262.344L262.666 429.147C262.699 428.946 262.673 428.79 262.589 428.677C262.507 428.564 262.374 428.507 262.19 428.507C262.068 428.507 261.956 428.533 261.853 428.586C261.751 428.638 261.665 428.715 261.595 428.816C261.527 428.916 261.481 429.036 261.457 429.176ZM265.371 431.07L266.096 426.702H268.988L268.86 427.464H266.892L266.721 428.505H268.498L268.37 429.266H266.593L266.295 431.07H265.371ZM270.446 426.702L271.077 428.191H271.111L272.246 426.702H273.318L271.627 428.886L272.623 431.07H271.58L270.932 429.58H270.898L269.755 431.07H268.678L270.411 428.886L269.428 426.702H270.446Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1660_8859",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1660_8859",
    transform: "matrix(0.00363856 0 0 0.00159422 -0.118514 -0.101894)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1660_8859",
    x1: 314.185,
    y1: 158.9,
    x2: 351.2,
    y2: 120.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#A47A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#A57B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#A67C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#A77D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#A77D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A97F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#AA7F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#AA8024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#AC8226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#AD8227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#AD8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#AE8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#AF8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#B08529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#B0862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#B1872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#B2872C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#B2882C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#B3892D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#B48A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B58A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#B88D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#BA8F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#BB9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#BD9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#BE9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481891,
    stopColor: "#BF9439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#C09539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#C1973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518109,
    stopColor: "#C3983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#C3983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#C3993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#C49A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#C69C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#C99F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#CEA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#D1A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#D3A84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D3A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#D4A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4AA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D5AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#D6AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#D9B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#DCB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#E0BC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E1BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E1BE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#E5C56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#E7C76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E9C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E9CB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EBCD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#EDCF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EDD077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#EED279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F1D67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#F1D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#F2D87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#F4DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996094,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DE85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1660_8859",
    x1: 302.472,
    y1: 173.765,
    x2: 340.689,
    y2: 133.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494696,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505304,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#A57B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#A57B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#A67C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#A77D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#A97F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#AA8024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#AC8226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#AD8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#AE8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#AF8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#AF8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#B0862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#B1872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#B2872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#B2882C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#B3892D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#B48A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#B58A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#B88D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#BA8F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#BB9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#BD9237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#BE9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#C0953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#C1963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#C2983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#C3983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#C4993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#C59B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C89E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#CBA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#CEA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1A74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1660_8859",
    x1: 324.701,
    y1: 141.203,
    x2: 356.383,
    y2: 108.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#B78C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#B88D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#BA8F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#BA9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#BC9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#BD9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#BD9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#BF9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C0953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#C1963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#C1973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#C3983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#C3993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#C4993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#C49A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#C69C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#C89E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#C99F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#CBA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#D0A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#D3A84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#D4A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#D4AA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#D4AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#D5AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#D6AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#D9B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#DAB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#DCB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#DEB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#E0BC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#E1BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#E2BF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E4C268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#E5C56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#E7C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#E7C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#EBCD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#EDD077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#EED178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#EFD37A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#F1D77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F2D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F3DA80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#F5DC84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#F6DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F7DF87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#F8E189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#F9E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FAE58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBE68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FCE88F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FEEA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FDE790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#FAE38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976563,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F7DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1660_8859",
    x1: 332.875,
    y1: 124.454,
    x2: 360.488,
    y2: 95.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#D5AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#D6AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#D8B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#DAB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#DBB559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#DCB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898437,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#DCB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#E0BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#E1BD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#E1BE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#E2BF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#E3C066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#E4C268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#E7C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#E9C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#E9CB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#EBCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EED178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#EED279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#EFD37A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#F0D57B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#F1D67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#F1D77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F2D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F6DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#F6DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F7DF87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#F7E088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F8E189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#F9E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F9E38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FAE48B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FAE58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FEEA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FDE891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566171,
    stopColor: "#FCE68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F4D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#F1D27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#EDCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#EAC56F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#E9C36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C16B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1660_8859",
    x1: 337.162,
    y1: 108.371,
    x2: 362.072,
    y2: 82.3241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#F7DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FAE48B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FEE992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#FCE68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FBE58E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FBE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FAE38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273437,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F8E088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F8DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#F7DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#F5D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421696,
    stopColor: "#F4D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F3D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#F3D680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#F1D37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#F1D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F0CF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578304,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#E9C46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#E7C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E8C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#EAC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EFC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1CA72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1660_8859",
    x1: 338.284,
    y1: 92.7173,
    x2: 359.369,
    y2: 70.6674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#F6DA84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#F5D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#F4D882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#F4D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F3D680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#F1D37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F1D27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#F0D17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#F0CF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#EAC46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414693,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E6BE6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E6BE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585307,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EBC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#F1CA71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1660_8859",
    x1: 336.971,
    y1: 80.3011,
    x2: 357.536,
    y2: 58.7951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#EDCB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#EBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EAC56F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#E9C46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#E9C36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#E7C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#E6BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E6BE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9C26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EBC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439774,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560226,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F7CF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FAD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#FAD277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1660_8859",
    x1: 335.265,
    y1: 69.123,
    x2: 353.527,
    y2: 50.0277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EBC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F0C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F4CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4616,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#FAD277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#F5CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#F0C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#E7C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7BF64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1660_8859",
    x1: 331.78,
    y1: 60.1606,
    x2: 349.724,
    y2: 41.3977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#ECC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F0C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#F4CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F7CF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F8D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FAD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476692,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523308,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F9D176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F4CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F0C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E8C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E8C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E5BE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E4BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#E3BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#E2BB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#E1BA5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#E0B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#E0B85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DDB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#DBB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8B156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1660_8859",
    x1: 327.514,
    y1: 52.1461,
    x2: 344.85,
    y2: 34.0187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489409,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510591,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#F7CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F3CC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E9C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#E5BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E5BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E4BD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E2BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#DFB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#DEB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#DEB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#DDB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#DCB559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#DBB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#D8B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#D7B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#D7AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#D6AE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#D5AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#D4AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#D3AC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#D3AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D2AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D1AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A94E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1660_8859",
    x1: 324.963,
    y1: 44.5372,
    x2: 338.73,
    y2: 30.1423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F4CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F8D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493324,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506676,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FBD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F6CE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F3CB70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F1C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#EFC86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#ECC569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#EAC368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E7C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#E7BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#E6BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E5BE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E4BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E2BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E1BA5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#DFB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#DDB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#DDB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#DCB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#DBB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D7B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D7AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6AF53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1660_8859",
    x1: 318.24,
    y1: 37.5464,
    x2: 330.814,
    y2: 24.3983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480359,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519641,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FDD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F5CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F3CC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F1C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EEC76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#EDC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#ECC569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#EAC368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E8C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E6BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E5BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#E5BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E4BD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#E2BB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#E1BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#E0B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E0B85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DFB85C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#DDB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#DDB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#DCB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1660_8859",
    x1: 185.573,
    y1: 158.907,
    x2: 148.557,
    y2: 120.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#A47A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#A57B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#A67C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#A77D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#A77D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A97F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#AA7F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#AA8024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#AC8226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#AD8227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#AD8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#AE8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#AF8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#B08529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#B0862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#B1872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#B2872C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#B2882C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#B3892D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#B48A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B58A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#B88D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#BA8F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#BB9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#BD9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#BE9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481891,
    stopColor: "#BF9439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#C09539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C0963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#C1973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518109,
    stopColor: "#C3983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#C3983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#C3993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#C49A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#C69C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#C99F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#CEA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#D1A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#D3A84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#D3A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#D4A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#D4AA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#D5AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#D6AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#D9B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#DCB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#E0BC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E1BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E1BE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#E5C56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#E7C76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E9C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E9CB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EBCD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#EDCF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EDD077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#EED279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F1D67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#F1D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#F2D87E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#F4DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996094,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DE85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1660_8859",
    x1: 197.278,
    y1: 173.765,
    x2: 159.061,
    y2: 133.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494696,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505304,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#A57B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#A57B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#A67C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#A77D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#A97F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#AA8024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#AC8226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#AD8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#AE8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#AF8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#AF8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#B0862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#B1872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#B2872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#B2882C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#B3892D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#B48A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#B58A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#B88D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#BA8F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#BB9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#BD9237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#BE9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#C0953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#C1963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#C2983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#C3983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#C4993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#C59B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#C89E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#CBA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#CEA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1A74B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1660_8859",
    x1: 175.088,
    y1: 141.203,
    x2: 143.406,
    y2: 108.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#B78C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#B88D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#B88E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#B98F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#BA8F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#BA9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#BB9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#BC9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#BC9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#BD9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#BD9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#BE9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#BF9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#BF9539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#C0953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#C1963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#C1973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#C3983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "#C3993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#C4993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#C49A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#C69C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#C89E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#C99F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#CBA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#D0A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#D3A84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#D4A94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#D4AA4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#D4AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#D5AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#D6AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#D9B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#DAB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#DCB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#DEB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#E0BC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#E1BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#E2BF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E4C268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#E5C56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#E7C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#E7C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#EBCD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#EDD077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#EED178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#EFD37A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#F1D77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F2D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F3DA80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#F5DC84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#F6DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F7DF87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#F8E189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#F9E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#FAE58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#FBE68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FCE88F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FEEA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FDE790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#FAE38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976563,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F7DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1660_8859",
    x1: 166.891,
    y1: 124.454,
    x2: 139.278,
    y2: 95.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#D5AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#D6AC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#D6AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#D7AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#D8B054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#D8B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#DAB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#DAB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#DBB559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#DBB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#DCB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898437,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#DCB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#DDB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#DEB95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#DEBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#DFBB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#E0BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#E1BD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#E1BE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#E2BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#E2BF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#E2C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#E3C066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#E3C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#E4C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#E4C268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E4C368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#E5C46A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#E6C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#E7C66C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#E8C86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#E9C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#E9CB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EACB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EBCD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#EBCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#ECCF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#EDD177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#EED178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#EED279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#EFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#EFD37A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#F0D47B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#F0D57B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#F1D67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#F1D67D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#F1D77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F2D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#F2D87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F6DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#F6DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F7DF87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#F7E088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F8E189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#F9E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F9E38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#FAE48B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#FAE58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#FCE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FEEA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FDE891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566171,
    stopColor: "#FCE68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F4D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F3D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#F1D27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#EDCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#EAC56F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#E9C36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C16B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1660_8859",
    x1: 162.596,
    y1: 108.375,
    x2: 137.686,
    y2: 82.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#F4DA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#F5DC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#F6DE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#F7DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#F7E087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F8E188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#F8E289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#F9E38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#FAE48B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FEE992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#FDE991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#FDE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCE78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#FCE68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#FBE58E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBE48D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#FBE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FAE38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273437,
    stopColor: "#FAE38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#F9E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F8E088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#F8DF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F8DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#F7DE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#F7DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#F5D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421696,
    stopColor: "#F4D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F3D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#F3D680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460937,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#F1D37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492187,
    stopColor: "#F1D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F0CF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578304,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#E9C46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#E7C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E8C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#EAC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EFC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1CA72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1660_8859",
    x1: 161.466,
    y1: 92.7173,
    x2: 140.381,
    y2: 70.6674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#F6DA84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5D983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#F5D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#F4D882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#F4D881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F4D781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#F4D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#F3D680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117187,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F3D57F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F2D47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148437,
    stopColor: "#F2D47D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#F1D37C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#F1D27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#F0D17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "#F0CF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EFCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304687,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#EAC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#EAC46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398437,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414693,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#E6BE6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#E6BE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585307,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EBC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#F1CA71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1660_8859",
    x1: 162.795,
    y1: 80.3011,
    x2: 142.229,
    y2: 58.7951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDCC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#EDCB76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#EDCA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#ECCA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#ECC973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#EBC872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#EBC772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#EBC671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#EAC570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EAC56F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#E9C46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#E9C46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#E9C36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#E7C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E7C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#E6BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E6BE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9C26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EBC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439774,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560226,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F7CF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FAD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#FAD277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5CE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1660_8859",
    x1: 164.477,
    y1: 69.1191,
    x2: 146.215,
    y2: 50.0238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#E8C06B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EBC36C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F0C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F4CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4616,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#FAD277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#F5CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#F0C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#E7C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7BF64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1660_8859",
    x1: 167.993,
    y1: 60.1606,
    x2: 150.049,
    y2: 41.3977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC46D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#ECC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#EEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F0C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#F4CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F7CF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F8D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#FAD278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476692,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523308,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F9D176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#F4CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#F0C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E8C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E8C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E5BE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E4BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#E3BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#E2BB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#E1BA5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#E0B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#E0B85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DDB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#DBB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8B156"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1660_8859",
    x1: 172.243,
    y1: 52.1461,
    x2: 154.907,
    y2: 34.0187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F0C870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F2CB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F9D277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489409,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510591,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554687,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585937,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#F7CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F3CC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#ECC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E9C267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773437,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#E5BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E5BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E4BD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E2BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#DFB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#DEB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#DEB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#DDB65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#DCB559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#DBB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#D9B256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#D8B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#D7B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#D7AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#D6AE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#D5AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#D4AD52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#D3AC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#D3AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D2AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D1AA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A94E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1660_8859",
    x1: 174.81,
    y1: 44.5372,
    x2: 161.044,
    y2: 30.1423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F4CC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F8D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493324,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506676,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#FBD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F6CE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F3CB70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F1C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#EFC86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#ECC569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#EAC368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E7C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#E7BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#E6BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E5BE62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#E4BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835937,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#E2BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E1BA5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867187,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#DFB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898437,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#DDB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#DDB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929687,
    stopColor: "#DCB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#DBB458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DAB358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DAB257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960937,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#D9B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#D8B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#D7B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#D7AF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6AF53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1660_8859",
    x1: 181.486,
    y1: 37.5464,
    x2: 168.913,
    y2: 24.3983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#F5CE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#F6CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FBD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FDD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480359,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519641,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#FDD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#FCD579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#FAD377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F9D176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F8D175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F7D074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F6CF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F5CE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648437,
    stopColor: "#F5CD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#F3CC71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#F3CC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F1CA6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#F1C96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#F0C86D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#EFC86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#EEC76C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "#EEC76B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EDC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#EDC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#ECC569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#ECC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#EBC468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#EAC368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#EAC367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E9C166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#E8C165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#E8C065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#E6BF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#E6BF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#E5BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#E5BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E4BD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#E4BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#E3BC60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#E2BB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#E1BA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#E1B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#E0B95E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#E0B85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945312,
    stopColor: "#DFB85C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#DFB75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#DDB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#DDB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#DCB55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#DCB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBB459"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1660_8859",
    x1: 261.046,
    y1: 176.455,
    x2: 241.772,
    y2: 125.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#A47A1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#A57B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#A67C20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664063,
    stopColor: "#A77D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#A87E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#A97F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#AA8024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820313,
    stopColor: "#AB8125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#AC8226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#AD8327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#AE8428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#AF8529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#B0862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#B1872B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#B2882C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#B3892D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#B48A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#B58B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#B68C30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#B78D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#B88D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#B98E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#BA8F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#BB9034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#BC9135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#BD9236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#BE9337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#BF9438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#C09539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#C1963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#C2973B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#C3983C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#C4993D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#C59A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#C69B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#C79C40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#C89D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#C99E42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#CA9F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#CBA044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#CCA145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#CDA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#CEA347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#CFA448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#D0A549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#D1A64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#D2A74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#D3A84C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#D4A94E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#D5AB4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D6AD51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#D7AF53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "#D9B155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#DAB357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#DBB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#DCB65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#DDB85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#DFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#E0BC61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#E1BE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#E2BF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#E3C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#E5C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#E6C56B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#E7C76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#E8C96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#E9CA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#EACC72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#ECCE74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#EDD076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#EED278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#EFD47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#F0D57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#F2D77E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F3D980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#F4DB82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "#F5DD84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#F6DF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F8E088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#F9E28A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#FAE48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#FBE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FCE890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#FFEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#FEEB93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#FEEA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#FDE891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#FCE790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#FCE68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FBE58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#FAE38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#FAE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#F9E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F8E089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#F8DF87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#F7DD86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#F6DC85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F6DB84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#F5DA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#F4D882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#F4D780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F3D67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#F2D57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#F2D37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#F1D27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F0D17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#F0D07A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#EFCE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#EECD77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#EECC76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#EDCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#ECC974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#ECC873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EBC771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#EAC670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#EAC46F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#E9C36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#E8C26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#E8C16C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#E7C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E7BF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#E7BF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#E8C06A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#E9C16B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#EAC26C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#EBC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#ECC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#EDC56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#EDC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#EEC66F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EFC770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#EFC870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#F0C871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#F1C971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#F1CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#F3CB73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#F3CC73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#F4CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#F5CD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#F5CE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#F6CF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F7CF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#F7D076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#F8D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#F9D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#F9D278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#FAD378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#FBD479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FCD57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#FDD67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#FED77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#FFD87C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#FDD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#FBD478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#F9D276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#F7CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#F4CD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#F0C96D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EEC66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#EBC469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#E9C266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#E7C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E5BD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#E2BB60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#DEB75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#DCB459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#D9B257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#D7B055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#D5AE52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D3AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#D0A94E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#CEA74C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#CCA44A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#CAA247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#C7A045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#C59E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#C39B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#C1993E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#BF973C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#BC953A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#BA9238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#B89036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#B68E33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#B38C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#B1892F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#AF872D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#AD852A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#AA8228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#A88026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#A67E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#A47C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#A1791F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#9F771D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#9D751B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#9B7319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#987017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#A7802A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#B58F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B58F3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B58F3E"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1660_8859",
    width: 340,
    height: 751,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulti1Desk);
export default __webpack_public_path__ + "static/media/multi_1_desk.291a495c94b34b132c8d7597c443c086.svg";
export { ForwardRef as ReactComponent };